(function(){
function hydrateVideo(video){if(!video||video.dataset.hydrated==='1')return video;if(video.dataset.src){video.src=video.dataset.src;video.removeAttribute('data-src')}video.querySelectorAll('source[data-src]').forEach(function(s){var media=s.getAttribute('media');if(!media||!window.matchMedia||window.matchMedia(media).matches){s.src=s.dataset.src;s.removeAttribute('data-src')}});video.dataset.hydrated='1';try{video.load()}catch(e){}return video}
window.AYLUHydrateVideo=hydrateVideo;
window.AYLUSceneVideoSwitch=function(sectionId,slot){var root=document.getElementById('lockee-reference-'+sectionId);if(!root)return;var action=root.querySelector('[data-action-scenes]');if(!action)return;action.querySelectorAll('[data-scene-slot] video').forEach(function(v){try{v.pause()}catch(e){}});var target=action.querySelector('[data-scene-slot="'+slot+'"]');if(!target)return;target.querySelectorAll('video').forEach(function(v){hydrateVideo(v);v.muted=true;v.defaultMuted=true;v.setAttribute('muted','');v.setAttribute('playsinline','');v.playsInline=true;v.loop=true;try{v.currentTime=0}catch(e){}try{var p=v.play();if(p&&p.catch)p.catch(function(){})}catch(e){}})};
})();
function initLockee(root){
if(!root||root.dataset.lrInitialized==='1')return;
root.dataset.lrInitialized='1';
var lrMobilePerf=!!(window.matchMedia&&window.matchMedia('(max-width:760px)').matches);
var howOrigin=root.querySelector('[data-how-tools-origin]'),howDest=root.querySelector('[data-how-desktop-tools]'),howAcc=root.querySelector('.lr-top-accordions'),howParent=root.querySelector('.lr-parent-jump--after-accordions'),howMq=window.matchMedia('(min-width:990px)');
function placeHowTools(){if(!howOrigin||!howDest||!howAcc)return;if(howMq.matches){howDest.appendChild(howAcc);if(howParent)howDest.appendChild(howParent)}else{howOrigin.insertAdjacentElement('afterend',howAcc);if(howParent)howAcc.insertAdjacentElement('afterend',howParent)}}placeHowTools();if(howMq.addEventListener)howMq.addEventListener('change',placeHowTools);else if(howMq.addListener)howMq.addListener(placeHowTools);
var moneyFormat=root.getAttribute('data-money-format')||'€{{amount_with_comma_separator}}';
function money(cents){
cents=parseInt(cents||0,10)||0;
if(window.Shopify&&typeof Shopify.formatMoney==='function')return Shopify.formatMoney(cents,moneyFormat);
return (cents/100).toFixed(2).replace('.',',')+' €';
}
function toast(msg){var t=root.querySelector('[data-toast]');if(!t)return;t.textContent=msg;t.hidden=false;clearTimeout(t._timer);t._timer=setTimeout(function(){t.hidden=true},2200)}
root.querySelectorAll('[data-scroll-buy]').forEach(function(b){b.addEventListener('click',function(){var a=root.querySelector('[data-buy-area]');if(a)a.scrollIntoView({behavior:'smooth',block:'center'})})});
var form=root.querySelector('form[id^="LockeeReferenceForm-"]');
var variantInput=root.querySelector('[data-variant-input]');
var qtyInput=root.querySelector('[data-qty]');
var qtyHidden=root.querySelector('[data-qty-hidden]');
var qtyMinus=root.querySelector('[data-qty-minus]');
var qtyPlus=root.querySelector('[data-qty-plus]');
var quickQty=Array.prototype.slice.call(root.querySelectorAll('[data-quick-qty]'));
var versions=Array.prototype.slice.call(root.querySelectorAll('[data-version]'));

/* V32: Negro y Naranja son variantes del MISMO producto.
   El color cambia variante, precio y galería sin recargar ni cambiar de URL. */
var colorSwitchLinks=Array.prototype.slice.call(root.querySelectorAll('[data-color-switch]'));
var requestedColor='';
try{
  var requestedColorParam=new URL(window.location.href).searchParams.get('color');
  if(requestedColorParam)requestedColor=normalizeColor(requestedColorParam);
}catch(e){}
var currentColor=requestedColor||normalizeColor(root.getAttribute('data-current-color')||'Negro');
var galleryColorApply=function(){};
function normalizeColor(value){
  return String(value||'').toLowerCase().indexOf('naranja')!==-1?'Naranja':'Negro';
}
function colorKey(color){return normalizeColor(color)==='Naranja'?'naranja':'negro'}
function selectedVersionButton(){return versions.find(function(v){return v.classList.contains('is-selected')})||versions[0]||null}
function refreshVersionButtonsForColor(color){
  var key=colorKey(color);
  versions.forEach(function(v){
    var id=v.getAttribute('data-variant-'+key)||'';
    var p=v.getAttribute('data-price-'+key)||'0';
    var a=v.getAttribute('data-available-'+key)||'false';
    if(id)v.setAttribute('data-variant',id);
    v.setAttribute('data-price-cents',p);
    v.setAttribute('data-available',a);
    v.disabled=!id;
  });
}
function cleanVariantUrl(){
  try{
    var url=new URL(window.location.href);
    url.searchParams.delete('variant');
    url.searchParams.delete('color');
    var q=url.searchParams.toString();
    history.replaceState({},'',url.pathname+(q?'?'+q:'')+url.hash);
  }catch(e){}
}
function applyProductColor(color,fromInit){
  currentColor=normalizeColor(color);
  root.setAttribute('data-current-color',currentColor);
  colorSwitchLinks.forEach(function(btn){
    var active=normalizeColor(btn.getAttribute('data-color-target'))===currentColor;
    btn.classList.toggle('is-current',active);
    btn.setAttribute('aria-checked',active?'true':'false');
  });
  refreshVersionButtonsForColor(currentColor);
  var selected=selectedVersionButton();
  if(selected){
    if(variantInput)variantInput.value=selected.getAttribute('data-variant')||'';
    currentPrice=parseInt(selected.getAttribute('data-price-cents')||0,10)||0;
    currentAvailable=selected.getAttribute('data-available')==='true';
  }
  if(typeof syncPurchase==='function')syncPurchase();
  galleryColorApply(currentColor,!!fromInit);
  cleanVariantUrl();
}
colorSwitchLinks.forEach(function(btn){
  btn.addEventListener('click',function(){applyProductColor(btn.getAttribute('data-color-target')||'Negro',false)});
});
var price=root.querySelector('[data-price]');
var preview=root.querySelector('[data-total-preview]');
var buyPrice=root.querySelector('[data-buy-price]');
var stickyPrice=root.querySelector('[data-sticky-price]');
var buyBtn=root.querySelector('[data-buy-now]');
var stickyBtn=root.querySelector('[data-sticky-buy]');
var buyLabel=root.querySelector('[data-buy-label]');
var mobileSticky=root.querySelector('[data-mobile-sticky]');
var stickyParent=root.querySelector('[data-sticky-parent]');
if(mobileSticky){
(function(){
var stickyMq=window.matchMedia('(max-width:760px)');
var lastScrollY=Math.max(0,window.pageYOffset||document.documentElement.scrollTop||0);
var stickyTicking=false;
var minDelta=6;
var minScroll=140;
function showMobileSticky(){
mobileSticky.classList.add('is-visible');
}
function hideMobileSticky(){
mobileSticky.classList.remove('is-visible');
}
function updateMobileSticky(){
var y=Math.max(0,window.pageYOffset||document.documentElement.scrollTop||0);
var delta=y-lastScrollY;
if(!stickyMq.matches || y<=minScroll){
hideMobileSticky();
}else if(delta<=-minDelta){
showMobileSticky();
}else if(delta>=minDelta){
hideMobileSticky();
}
if(Math.abs(delta)>=minDelta){
lastScrollY=y;
}
stickyTicking=false;
}
hideMobileSticky();
window.addEventListener('scroll',function(){
if(stickyTicking)return;
stickyTicking=true;
window.requestAnimationFrame(updateMobileSticky);
},{passive:true});
function resetStickyForViewport(){
lastScrollY=Math.max(0,window.pageYOffset||document.documentElement.scrollTop||0);
hideMobileSticky();
}
if(typeof stickyMq.addEventListener==='function')stickyMq.addEventListener('change',resetStickyForViewport);
else if(typeof stickyMq.addListener==='function')stickyMq.addListener(resetStickyForViewport);
})();
}
var giftFloat=root.querySelector('[data-gift-float]');
if(giftFloat){
var giftToggle=giftFloat.querySelector('[data-gift-toggle]');
var giftClose=giftFloat.querySelector('[data-gift-close]');
var giftPanel=giftFloat.querySelector('[data-gift-panel]');
function setGiftOpen(open){
giftFloat.classList.toggle('is-open',!!open);
if(giftToggle)giftToggle.setAttribute('aria-expanded',open?'true':'false');
if(giftPanel)giftPanel.setAttribute('aria-hidden',open?'false':'true');
}
window.setTimeout(function(){giftFloat.classList.add('is-ready')},4000);
if(giftToggle)giftToggle.addEventListener('click',function(){setGiftOpen(!giftFloat.classList.contains('is-open'))});
if(giftClose)giftClose.addEventListener('click',function(){setGiftOpen(false)});
document.addEventListener('click',function(e){
if(giftFloat.classList.contains('is-open')&&!giftFloat.contains(e.target))setGiftOpen(false);
});
}
root.querySelectorAll('video[data-lazy-autoplay]').forEach(function(video){
function startLazy(){if(window.AYLUHydrateVideo)window.AYLUHydrateVideo(video);video.muted=true;video.setAttribute('muted','');video.setAttribute('playsinline','');try{var p=video.play();if(p&&p.catch)p.catch(function(){})}catch(e){}}
if('IntersectionObserver' in window){
var ioOpts=lrMobilePerf?{rootMargin:'0px',threshold:[.55]}:{rootMargin:'350px 0px',threshold:.01};
var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){var ready=lrMobilePerf?(entry.isIntersecting&&entry.intersectionRatio>=.55):entry.isIntersecting;if(ready){startLazy();io.disconnect()}})},ioOpts);
io.observe(video)
}else if(!lrMobilePerf){startLazy()}
});
if(lrMobilePerf){
root.querySelectorAll('video[data-mobile-deferred-video]').forEach(function(video){
var hydrateOnce=function(){if(window.AYLUHydrateVideo)window.AYLUHydrateVideo(video)};
['pointerdown','touchstart','click'].forEach(function(evt){video.addEventListener(evt,hydrateOnce,{passive:true,once:true})});
if('IntersectionObserver' in window){
var deferredIo=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting&&entry.intersectionRatio>=.55){hydrateOnce();deferredIo.disconnect()}})},{rootMargin:'0px',threshold:[.55]});
deferredIo.observe(video);
}
});
}
root.querySelectorAll('video[data-mobile-how-video]').forEach(function(video){
var hydrateHow=function(){if(window.AYLUHydrateVideo)window.AYLUHydrateVideo(video);video.preload='metadata'};
['pointerdown','touchstart','click'].forEach(function(evt){video.addEventListener(evt,hydrateHow,{passive:true,once:true})});
if('IntersectionObserver' in window){var howIo=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){hydrateHow();howIo.disconnect()}})},{rootMargin:'220px 0px',threshold:.01});howIo.observe(video)}
});

var accessory=root.querySelector('[data-accessory]');
var accessoryToggle=root.querySelector('[data-accessory-toggle]');
var currentPrice=parseInt(root.getAttribute('data-current-price')||'0',10)||0;
var currentAvailable=root.getAttribute('data-current-available')==='true';
var cartLayer=root.querySelector('[data-cart-layer]');
var cartDrawer=root.querySelector('[data-cart-drawer]');
var cartItemsEl=root.querySelector('[data-cart-items]');
var cartEmptyEl=root.querySelector('[data-cart-empty]');
var cartLoadingEl=root.querySelector('[data-cart-loading]');
var cartFooter=root.querySelector('[data-cart-footer]');
var cartCountEl=root.querySelector('[data-cart-count]');
var cartSubtotalEl=root.querySelector('[data-cart-subtotal]');
var cartTotalEl=root.querySelector('[data-cart-total]');
var cartShippingRow=root.querySelector('[data-cart-shipping-row]');
var cartShippingEl=root.querySelector('[data-cart-shipping]');
var cartDiscountRow=root.querySelector('[data-cart-discount-row]');
var cartDiscountEl=root.querySelector('[data-cart-discount]');
var cartCheckout=root.querySelector('[data-cart-checkout]');
var cartCheckoutNote=root.querySelector('[data-cart-checkout-note]');
var cartBundle=root.querySelector('[data-cart-bundle]');
var cartBundleEyebrow=root.querySelector('[data-cart-bundle-eyebrow]');
var cartBundleBadge=root.querySelector('[data-cart-bundle-badge]');
var cartBundleTitle=root.querySelector('[data-cart-bundle-title]');
var cartBundleCopy=root.querySelector('[data-cart-bundle-copy]');
var cartBundleColors=root.querySelector('[data-cart-bundle-colors]');
var cartBundleBefore=root.querySelector('[data-cart-bundle-before]');
var cartBundleAfter=root.querySelector('[data-cart-bundle-after]');
var cartBundleSave=root.querySelector('[data-cart-bundle-save]');
var cartBundleAdd=root.querySelector('[data-cart-bundle-add]');
var cartBundleNote=root.querySelector('[data-cart-bundle-note]');
var cartBundleColorBtns=Array.prototype.slice.call(root.querySelectorAll('[data-cart-bundle-color]'));
var cartBundleData=root.querySelector('[data-cart-bundle-variants]');
var cartDuoSwitch=root.querySelector('[data-cart-duo-switch]');
var cartDuoSwitchCopy=root.querySelector('[data-cart-duo-switch-copy]');
var cartDuoSwitchMedia=root.querySelector('[data-cart-duo-switch-media]');
var cartDuoSwitchDevices=root.querySelector('[data-cart-duo-switch-devices]');
var cartDuoSwitchCompare=root.querySelector('[data-cart-duo-switch-compare]');
var cartDuoSwitchPrice=root.querySelector('[data-cart-duo-switch-price]');
var cartDuoSwitchSaving=root.querySelector('[data-cart-duo-switch-saving]');
var cartDuoSwitchButton=root.querySelector('[data-cart-duo-switch-button]');
var cartDuoSwitchNote=root.querySelector('[data-cart-duo-switch-note]');
var cartDuoColorsEl=root.querySelector('[data-cart-duo-colors]');
var cartDuoVariantsData=root.querySelector('[data-cart-duo-variants]');
var cartPackOffers=root.querySelector('[data-cart-pack-offers]');
var cartFamilySwitch=root.querySelector('[data-cart-family-switch]');
var cartFamilySwitchCopy=root.querySelector('[data-cart-family-switch-copy]');
var cartFamilySwitchMedia=root.querySelector('[data-cart-family-switch-media]');
var cartFamilySwitchDevices=root.querySelector('[data-cart-family-switch-devices]');
var cartFamilySwitchCompare=root.querySelector('[data-cart-family-switch-compare]');
var cartFamilySwitchPrice=root.querySelector('[data-cart-family-switch-price]');
var cartFamilySwitchSaving=root.querySelector('[data-cart-family-switch-saving]');
var cartFamilySwitchButton=root.querySelector('[data-cart-family-switch-button]');
var cartFamilySwitchNote=root.querySelector('[data-cart-family-switch-note]');
var cartFamilyColorsEl=root.querySelector('[data-cart-family-colors]');
var cartFamilyVariantsData=root.querySelector('[data-cart-family-variants]');
var cartCloseEls=Array.prototype.slice.call(root.querySelectorAll('[data-cart-close]'));
var cartBusy=false;
var lastCartFocus=null;
var lastCartState=null;
var bundleVariants=[];
var bundleSelectedColor='Negro';
var bundleEnabled=false; // V19: eliminado el descuento/upsell de 2 Lockee
var bundlePercent=parseInt(cartLayer&&cartLayer.getAttribute('data-bundle-discount-percent')||15,10)||15;
var bundleMinQty=parseInt(cartLayer&&cartLayer.getAttribute('data-bundle-min-qty')||2,10)||2;
var bundleCode=''; // V19: checkout siempre sin código automático x2
var duoPackHandle=(cartLayer&&cartLayer.getAttribute('data-duo-pack-handle')||'pack-duo-lockee').trim();
var duoPackImage=normalizeImage(cartLayer&&cartLayer.getAttribute('data-duo-pack-image')||'');
var duoPackPrice=parseInt(cartLayer&&cartLayer.getAttribute('data-duo-pack-price')||4490,10)||4490;
var duoPackCompare=parseInt(cartLayer&&cartLayer.getAttribute('data-duo-pack-compare')||4980,10)||4980;
var familyPackHandle=(cartLayer&&cartLayer.getAttribute('data-family-pack-handle')||'pack-familiar-lockee').trim();
var familyPackImage=normalizeImage(cartLayer&&cartLayer.getAttribute('data-family-pack-image')||'');
var familyPackPrice=parseInt(cartLayer&&cartLayer.getAttribute('data-family-pack-price')||5790,10)||5790;
var familyPackCompare=parseInt(cartLayer&&cartLayer.getAttribute('data-family-pack-compare')||7470,10)||7470;
var strictShippingFee=parseInt(cartLayer&&cartLayer.getAttribute('data-strict-shipping')||399,10)||399;
var freeShippingThreshold=parseInt(cartLayer&&cartLayer.getAttribute('data-free-shipping-threshold')||1791,10)||1791;
var duoOfferColors=['Negro','Negro'];
var familyOfferColors=['Negro','Negro','Negro'];
var lastDuoOfferKey='';
var lastFamilyOfferKey='';
var duoVariants=[];
var familyVariants=[];
try{bundleVariants=JSON.parse(cartBundleData&&cartBundleData.textContent||'[]')}catch(e){bundleVariants=[]}
try{duoVariants=JSON.parse(cartDuoVariantsData&&cartDuoVariantsData.textContent||'[]')}catch(e){duoVariants=[]}
try{familyVariants=JSON.parse(cartFamilyVariantsData&&cartFamilyVariantsData.textContent||'[]')}catch(e){familyVariants=[]}

function esc(value){
return String(value==null?'':value).replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch]});
}
function cartRoot(){return window.Shopify&&Shopify.routes?Shopify.routes.root:'/'}
function cartUrl(path){var base=cartRoot();return base+(base.slice(-1)==='/'?'':'/')+path.replace(/^\//,'')}
function normalizeImage(url){if(!url)return '';return String(url).indexOf('//')===0?'https:'+url:String(url)}
function itemHandle(item){
if(item&&item.handle)return String(item.handle);
var url=item&&item.url?String(item.url):'';
var m=url.match(/\/products\/([^?/#]+)/);
return m&&m[1]?m[1]:'';
}
function isIndividualLockee(item){
var h=itemHandle(item);
return h==='lockee'||h==='lockee-naranja';
}
function isDuoPackItem(item){return itemHandle(item)===duoPackHandle}
function isFamilyPackItem(item){return itemHandle(item)===familyPackHandle}
function originalLinePrice(item){
if(item&&item.original_line_price!=null)return parseInt(item.original_line_price,10)||0;
if(item&&item.line_price!=null)return parseInt(item.line_price,10)||0;
return 0;
}
function currentLinePrice(item){
if(item&&item.final_line_price!=null)return parseInt(item.final_line_price,10)||0;
return originalLinePrice(item);
}
function lockeeVersion(item){
if(item&&item.options_with_values&&item.options_with_values.length){
var first=item.options_with_values[0];
if(first&&first.value)return String(first.value);
}
var t=item&&item.variant_title&&item.variant_title!=='Default Title'?String(item.variant_title):'';
return t.split(' / ')[0]||'';
}
function lockeeColor(item){
if(item&&item.options_with_values&&item.options_with_values.length){
  var colorOpt=item.options_with_values.find(function(o){return o&&String(o.name||'').toLowerCase()==='color'});
  if(colorOpt&&colorOpt.value)return normalizeColor(colorOpt.value);
  if(item.options_with_values[1]&&item.options_with_values[1].value)return normalizeColor(item.options_with_values[1].value);
}
var h=itemHandle(item);
return h==='lockee-naranja'?'Naranja':'Negro';
}
function openingsCount(version){
return version==='Flex'?2:(version==='Balance'?1:0);
}
function openingsLabel(version){
var n=openingsCount(version);
return n+' '+(n===1?'apertura':'aperturas')+' de emergencia';
}
function cartVersionCounts(metrics){
var counts={Strict:0,Balance:0,Flex:0};
(metrics&&metrics.individualLines||[]).forEach(function(line){
var version=lockeeVersion(line.item);
var q=parseInt(line.quantity||0,10)||0;
if(counts.hasOwnProperty(version))counts[version]+=q;
});
return counts;
}
function selectedVersionsSummary(metrics){
var counts=cartVersionCounts(metrics);
var pieces=[];
['Strict','Balance','Flex'].forEach(function(version){
var count=counts[version]||0;
if(!count)return;
pieces.push((count===1?'1 Lockee ':count+' Lockee ')+version+' ('+openingsLabel(version)+')');
});
return pieces.join(' · ');
}
function familyUpgradeExplanation(metrics){
var summary=selectedVersionsSummary(metrics);
if(!summary)return 'Con el Pack Familiar tendrás 3 Lockee Flex con 2 aperturas de emergencia cada uno por '+money(familyPackPrice)+'.';
return 'Ahora llevas '+summary+'. Con el Pack Familiar tendrás 3 Lockee Flex con 2 aperturas de emergencia cada uno por '+money(familyPackPrice)+'.';
}
function duoPackProperties(colors){
return {
'Incluye':'2 Lockee Flex · 2 aperturas de emergencia cada uno · Envío gratis',
'Pensado para':'Dos hermanos · pareja · padre e hijo'
};
}
function familyPackProperties(colors){
return {
'Incluye':'3 Lockee Flex · 2 aperturas de emergencia cada uno · Envío gratis'
};
}
function packColorsFromItem(item,count){
var colors=[];
if(item&&item.options_with_values&&item.options_with_values.length){
item.options_with_values.forEach(function(o){if(o&&o.value&&colors.length<count)colors.push(normalizeColor(o.value))});
}
if(!colors.length&&item&&item.variant_title&&item.variant_title!=='Default Title'){
String(item.variant_title).split(' / ').forEach(function(v){if(colors.length<count)colors.push(normalizeColor(v))});
}
while(colors.length<count)colors.push(colors[colors.length-1]||'Negro');
return colors.slice(0,count);
}
function cartMetrics(cart){
var items=cart&&cart.items?cart.items:[];
var individualQty=0;
var individualSubtotal=0;
var duoPresent=false;
var familyPresent=false;
var duoItem=null;
var familyItem=null;
var duoLines=[];
var familyLines=[];
var firstIndividual=null;
var individualColors=[];
var individualLines=[];
var hasStrictIndividual=false;
items.forEach(function(item,index){
if(isDuoPackItem(item)){duoPresent=true;if(!duoItem)duoItem=item;duoLines.push({key:item.key,line:index+1,quantity:item.quantity||1,item:item});}
if(isFamilyPackItem(item)){familyPresent=true;if(!familyItem)familyItem=item;familyLines.push({key:item.key,line:index+1,quantity:item.quantity||1,item:item});}
if(isIndividualLockee(item)){
var q=parseInt(item.quantity||0,10)||0;
individualQty+=q;
individualSubtotal+=originalLinePrice(item);
if(!firstIndividual)firstIndividual=item;
individualLines.push({key:item.key,line:index+1,quantity:q,item:item});
if(lockeeVersion(item)==='Strict')hasStrictIndividual=true;
var color=lockeeColor(item);
for(var n=0;n<q;n++)individualColors.push(color);
}
});
var subtotal=(cart&&cart.items_subtotal_price!=null)?parseInt(cart.items_subtotal_price,10)||0:(cart&&cart.total_price!=null?parseInt(cart.total_price,10)||0:0);
var qualifies=bundleEnabled&&individualQty===bundleMinQty;
var projectedDiscount=qualifies?Math.round(individualSubtotal*(bundlePercent/100)):0;
var strictShippingApplies=hasStrictIndividual&&!duoPresent&&!familyPresent&&subtotal<freeShippingThreshold;
return {
items:items,individualQty:individualQty,individualSubtotal:individualSubtotal,individualColors:individualColors,
individualLines:individualLines,duoPresent:duoPresent,familyPresent:familyPresent,duoItem:duoItem,familyItem:familyItem,
duoLines:duoLines,familyLines:familyLines,firstIndividual:firstIndividual,hasStrictIndividual:hasStrictIndividual,
subtotal:subtotal,strictShippingApplies:strictShippingApplies,estimatedShipping:strictShippingApplies?strictShippingFee:0,
qualifies:qualifies,projectedDiscount:projectedDiscount,projectedTotal:Math.max(0,subtotal-projectedDiscount)
};
}
function discountCheckoutHref(cart){
var metrics=cartMetrics(cart);
if(metrics.qualifies&&bundleCode){
return cartUrl('discount/'+encodeURIComponent(bundleCode))+'?redirect='+encodeURIComponent(cartUrl('checkout'));
}
return cartUrl('checkout');
}
function openCart(){
if(!cartLayer)return;
lastCartFocus=document.activeElement;
clearTimeout(cartLayer._hideTimer);
if(cartLayer.parentNode!==document.body)document.body.appendChild(cartLayer);
cartLayer.hidden=false;
cartLayer.setAttribute('aria-hidden','false');
document.body.classList.add('lr-cart-locked');
requestAnimationFrame(function(){
cartLayer.classList.add('is-open');
if(cartDrawer){cartDrawer.setAttribute('tabindex','-1');try{cartDrawer.focus({preventScroll:true})}catch(e){cartDrawer.focus()}}
});
}
function closeCart(){
if(!cartLayer)return;
cartLayer.classList.remove('is-open');
cartLayer.setAttribute('aria-hidden','true');
document.body.classList.remove('lr-cart-locked');
clearTimeout(cartLayer._hideTimer);
cartLayer._hideTimer=setTimeout(function(){cartLayer.hidden=true},340);
if(lastCartFocus&&typeof lastCartFocus.focus==='function'){try{lastCartFocus.focus({preventScroll:true})}catch(e){}}
}
cartCloseEls.forEach(function(el){el.addEventListener('click',closeCart)});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&cartLayer&&!cartLayer.hidden)closeCart()});

function findBundleVariant(version,color){
return bundleVariants.find(function(v){return v&&v.available&&v.version===version&&v.color===color})||
bundleVariants.find(function(v){return v&&v.available&&v.version===version})||null;
}
function setBundleColor(color){
bundleSelectedColor=color;
cartBundleColorBtns.forEach(function(btn){
var active=btn.getAttribute('data-cart-bundle-color')===color;
btn.setAttribute('aria-pressed',active?'true':'false');
});
if(lastCartState)renderBundle(lastCartState,cartMetrics(lastCartState));
}
cartBundleColorBtns.forEach(function(btn){
btn.addEventListener('click',function(){
if(btn.disabled)return;
setBundleColor(btn.getAttribute('data-cart-bundle-color')||'Negro');
});
});

function renderBundle(cart,metrics){
if(!cartBundle)return;
cartBundle.classList.remove('is-active');

if(!bundleEnabled||!metrics.individualQty||metrics.individualQty>=3){
cartBundle.hidden=true;
return;
}
cartBundle.hidden=false;

if(metrics.individualQty===bundleMinQty){
cartBundle.classList.add('is-active');
if(cartBundleEyebrow)cartBundleEyebrow.textContent='DESCUENTO DESBLOQUEADO';
if(cartBundleBadge)cartBundleBadge.textContent='-'+bundlePercent+'%';
if(cartBundleTitle)cartBundleTitle.textContent=bundlePercent+'% aplicado a tus 2 Lockee';
if(cartBundleCopy)cartBundleCopy.textContent='El 15% se aplica automáticamente al pagar.';
if(cartBundleBefore)cartBundleBefore.textContent=money(metrics.individualSubtotal);
if(cartBundleAfter)cartBundleAfter.textContent=money(Math.max(0,metrics.individualSubtotal-metrics.projectedDiscount));
if(cartBundleSave)cartBundleSave.textContent='Ahorras '+money(metrics.projectedDiscount);
if(cartBundleNote)cartBundleNote.textContent='¿Quieres un tercero? Pack Familiar: 3 Flex · 2 aperturas cada uno · '+money(familyPackPrice)+'.';
return;
}

var first=metrics.firstIndividual;
var version=lockeeVersion(first);
var firstColor=lockeeColor(first);
if(!bundleSelectedColor)bundleSelectedColor=firstColor;
var candidate=findBundleVariant(version,bundleSelectedColor);

cartBundleColorBtns.forEach(function(btn){
var color=btn.getAttribute('data-cart-bundle-color');
var v=findBundleVariant(version,color);
btn.disabled=!v;
});
if(!candidate){
candidate=findBundleVariant(version,firstColor);
if(candidate)bundleSelectedColor=candidate.color;
}
cartBundleColorBtns.forEach(function(btn){
var active=btn.getAttribute('data-cart-bundle-color')===bundleSelectedColor;
btn.setAttribute('aria-pressed',active?'true':'false');
});

if(cartBundleEyebrow)cartBundleEyebrow.textContent='AHORRA EN TU PEDIDO';
if(cartBundleBadge)cartBundleBadge.textContent='-'+bundlePercent+'%';
if(cartBundleTitle)cartBundleTitle.textContent='Llévate 2 Lockee y ahorra un '+bundlePercent+'%';
if(cartBundleCopy)cartBundleCopy.textContent=version?'Añade otro Lockee '+version+' y activa el descuento.':'Añade un segundo Lockee y activa el descuento.';

if(!candidate){
if(cartBundleAdd){cartBundleAdd.disabled=true;cartBundleAdd.textContent='Sin stock para esta combinación';}
if(cartBundleBefore)cartBundleBefore.textContent='';
if(cartBundleAfter)cartBundleAfter.textContent='';
if(cartBundleSave)cartBundleSave.textContent='';
return;
}

var before=metrics.individualSubtotal+(parseInt(candidate.price,10)||0);
var saving=Math.round(before*(bundlePercent/100));
var after=Math.max(0,before-saving);
if(cartBundleBefore)cartBundleBefore.textContent=money(before);
if(cartBundleAfter)cartBundleAfter.textContent=money(after);
if(cartBundleSave)cartBundleSave.textContent='Ahorras '+money(saving);
if(cartBundleAdd){
cartBundleAdd.disabled=false;
cartBundleAdd.setAttribute('data-variant-id',candidate.id);
cartBundleAdd.textContent='Añadir segundo Lockee · activar -'+bundlePercent+'%';
}
if(cartBundleNote)cartBundleNote.textContent='Añade un tercero y desbloquea el Pack Familiar por '+money(familyPackPrice)+'.';
}

if(cartBundleAdd)cartBundleAdd.addEventListener('click',function(){
var id=parseInt(cartBundleAdd.getAttribute('data-variant-id')||0,10);
if(!id||cartBusy)return;
cartBusy=true;
cartBundleAdd.disabled=true;
var oldText=cartBundleAdd.textContent;
cartBundleAdd.textContent='Añadiendo…';
if(cartDrawer)cartDrawer.classList.add('is-loading');
fetch(cartUrl('cart/add.js'),{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({items:[{id:id,quantity:1}]})
})
.then(function(r){if(!r.ok)throw new Error('cart-add');return r.json()})
.then(function(){return getCart(false)})
.catch(function(){toast('No se ha podido añadir el segundo Lockee.')})
.finally(function(){
cartBusy=false;
if(cartDrawer)cartDrawer.classList.remove('is-loading');
cartBundleAdd.textContent=oldText;
if(lastCartState)renderBundle(lastCartState,cartMetrics(lastCartState));
});
});


function offerColors(metrics,count){
var colors=[];
if(metrics&&metrics.duoPresent&&metrics.duoItem&&count>=2)colors=packColorsFromItem(metrics.duoItem,2);
else colors=(metrics&&metrics.individualColors?metrics.individualColors:[]).slice(0,count);
var fallback=colors.length?colors[colors.length-1]:(metrics&&metrics.firstIndividual?lockeeColor(metrics.firstIndividual):'Negro');
while(colors.length<count)colors.push(fallback||'Negro');
return colors.slice(0,count);
}
function offerKey(metrics,type){
return [type,metrics.individualQty,metrics.duoPresent?'d':'',metrics.familyPresent?'f':'',metrics.subtotal,(metrics.individualColors||[]).join('-'),metrics.duoItem&&metrics.duoItem.key||''].join('|');
}
function findDuoVariant(colors){
if(!colors||colors.length<2)return null;
return duoVariants.find(function(v){return v&&v.available&&v.options&&normalizeColor(v.options[0])===normalizeColor(colors[0])&&normalizeColor(v.options[1])===normalizeColor(colors[1])})||null;
}
function findFamilyVariant(colors){
if(!colors||colors.length<3)return null;
return familyVariants.find(function(v){return v&&v.available&&v.options&&normalizeColor(v.options[0])===normalizeColor(colors[0])&&normalizeColor(v.options[1])===normalizeColor(colors[1])&&normalizeColor(v.options[2])===normalizeColor(colors[2])})||null;
}
function renderPackColorSelectors(el,colors,type){
if(!el)return;
el.innerHTML=colors.map(function(color,index){
return '<div class="lr-cart-pack-color-row"><span>Lockee '+(index+1)+'</span><div class="lr-cart-pack-color-options">'+
['Negro','Naranja'].map(function(opt){return '<button type="button" class="lr-cart-pack-color-btn '+(normalizeColor(color)===opt?'is-selected':'')+'" data-cart-pack-color="'+type+'" data-pack-index="'+index+'" data-color="'+opt+'" aria-pressed="'+(normalizeColor(color)===opt?'true':'false')+'">'+opt+'</button>'}).join('')+
'</div></div>';
}).join('');
}
function renderDuoSwitchDevices(colors){
if(!cartDuoSwitchDevices)return;
var chosen=(colors||[]).slice(0,2);while(chosen.length<2)chosen.push(chosen[0]||'Negro');
cartDuoSwitchDevices.innerHTML=chosen.map(function(color,index){return cartMiniImageHtml(cartVariantImageByColor(color),'Lockee '+color,index)}).join('');
}
function currentShippingBonus(metrics){return strictShippingFee}
function syncDuoOffer(metrics){
var duoVariant=findDuoVariant(duoOfferColors);
var saving=Math.max(0,duoPackCompare-duoPackPrice)+currentShippingBonus(metrics);
renderDuoSwitchDevices(duoOfferColors);renderPackColorSelectors(cartDuoColorsEl,duoOfferColors,'duo');
if(cartDuoSwitchCompare)cartDuoSwitchCompare.textContent=money(duoPackCompare);
if(cartDuoSwitchPrice)cartDuoSwitchPrice.textContent=money(duoPackPrice);
if(cartDuoSwitchSaving)cartDuoSwitchSaving.textContent=(saving>0?'Ventaja total '+money(saving)+' · ':'')+'Envío gratis';
if(cartDuoSwitchCopy)cartDuoSwitchCopy.textContent='Incluye 2 Lockee Flex con 2 aperturas de emergencia por Lockee.';
if(cartDuoSwitchButton){cartDuoSwitchButton.disabled=!duoVariant;cartDuoSwitchButton.setAttribute('data-duo-variant-id',duoVariant?duoVariant.id:'');cartDuoSwitchButton.textContent=duoVariant?'Cambiar a Pack Dúo · '+money(duoPackPrice):'Combinación no disponible';}
if(cartDuoSwitchNote)cartDuoSwitchNote.textContent=currentShippingBonus(metrics)>0?'El ahorro mostrado incluye también el envío que evitarías con el pack.':'Configura el color de cada Lockee.';
}
function renderDuoSwitch(cart,metrics){
if(!cartDuoSwitch)return;
var show=metrics.individualQty>=1&&metrics.individualQty<=2&&!metrics.duoPresent&&!metrics.familyPresent&&duoVariants.length>0;
if(!show){cartDuoSwitch.hidden=true;return;}
cartDuoSwitch.hidden=false;
var key=offerKey(metrics,'duo');if(key!==lastDuoOfferKey){duoOfferColors=offerColors(metrics,2);lastDuoOfferKey=key;}
syncDuoOffer(metrics);
}
function replaceWithDuoPack(variantId){
if(!lastCartState||cartBusy||!variantId)return;var metrics=cartMetrics(lastCartState);if(metrics.individualQty<1||metrics.individualQty>2)return;
var colors=duoOfferColors.slice(0,2);cartBusy=true;if(cartDrawer)cartDrawer.classList.add('is-loading');
if(cartDuoSwitchButton){cartDuoSwitchButton.disabled=true;cartDuoSwitchButton.textContent='Cambiando…';}
var updates={};metrics.individualLines.forEach(function(line){if(line.key)updates[line.key]=0;});
fetch(cartUrl('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})})
.then(function(r){if(!r.ok)throw new Error('cart-update');return r.json()})
.then(function(){return fetch(cartUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(variantId,10),quantity:1,properties:duoPackProperties(colors)}]})})})
.then(function(r){if(!r.ok)throw new Error('cart-add-duo');return r.json()}).then(function(){return getCart(false)})
.catch(function(){toast('No se ha podido cambiar al Pack Dúo. Inténtalo de nuevo.')}).finally(function(){cartBusy=false;if(cartDrawer)cartDrawer.classList.remove('is-loading')});
}
function renderFamilySwitchDevices(colors){
if(!cartFamilySwitchDevices)return;var chosen=(colors||[]).slice(0,3);while(chosen.length<3)chosen.push(chosen[0]||'Negro');
cartFamilySwitchDevices.innerHTML=chosen.map(function(color,index){return cartMiniImageHtml(cartVariantImageByColor(color),'Lockee '+color,index)}).join('');
}
function syncFamilyOffer(metrics){
var familyVariant=findFamilyVariant(familyOfferColors);var saving=Math.max(0,familyPackCompare-familyPackPrice)+currentShippingBonus(metrics);
renderFamilySwitchDevices(familyOfferColors);renderPackColorSelectors(cartFamilyColorsEl,familyOfferColors,'family');
if(cartFamilySwitchCompare)cartFamilySwitchCompare.textContent=money(familyPackCompare);
if(cartFamilySwitchPrice)cartFamilySwitchPrice.textContent=money(familyPackPrice);
if(cartFamilySwitchSaving)cartFamilySwitchSaving.textContent=(saving>0?'Ventaja total '+money(saving)+' · ':'')+'Envío gratis';
if(cartFamilySwitchCopy)cartFamilySwitchCopy.textContent='Incluye 3 Lockee Flex con 2 aperturas de emergencia por Lockee.';
if(cartFamilySwitchButton){cartFamilySwitchButton.hidden=false;cartFamilySwitchButton.disabled=!familyVariant;cartFamilySwitchButton.setAttribute('data-family-variant-id',familyVariant?familyVariant.id:'');cartFamilySwitchButton.textContent=familyVariant?(metrics.duoPresent?'Subir a Pack Familiar · ':'Cambiar a Pack Familiar · ')+money(familyPackPrice):'Combinación no disponible';}
if(cartFamilySwitchNote)cartFamilySwitchNote.textContent=metrics.duoPresent?'Añades un tercer Flex y eliges el color de los tres.':(currentShippingBonus(metrics)>0?'El ahorro mostrado incluye también el envío que evitarías con el pack.':'Configura el color de cada Lockee.');
}
function renderFamilySwitch(cart,metrics){
if(!cartFamilySwitch)return;
var fromIndividuals=metrics.individualQty>=1&&metrics.individualQty<=3&&!metrics.duoPresent&&!metrics.familyPresent;
var fromDuo=metrics.duoPresent&&!metrics.familyPresent&&metrics.individualQty===0;
var show=(fromIndividuals||fromDuo)&&familyVariants.length>0;if(!show){cartFamilySwitch.hidden=true;return;}
cartFamilySwitch.hidden=false;var key=offerKey(metrics,'family');if(key!==lastFamilyOfferKey){familyOfferColors=offerColors(metrics,3);lastFamilyOfferKey=key;}syncFamilyOffer(metrics);
}
function replaceWithFamilyPack(variantId){
if(!lastCartState||cartBusy||!variantId)return;var metrics=cartMetrics(lastCartState);if(!((metrics.individualQty>=1&&metrics.individualQty<=3)||metrics.duoPresent))return;
var colors=familyOfferColors.slice(0,3);cartBusy=true;if(cartDrawer)cartDrawer.classList.add('is-loading');if(cartFamilySwitchButton){cartFamilySwitchButton.disabled=true;cartFamilySwitchButton.textContent='Cambiando…';}
var updates={};metrics.individualLines.forEach(function(line){if(line.key)updates[line.key]=0;});metrics.duoLines.forEach(function(line){if(line.key)updates[line.key]=0;});
fetch(cartUrl('cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})})
.then(function(r){if(!r.ok)throw new Error('cart-update');return r.json()})
.then(function(){return fetch(cartUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(variantId,10),quantity:1,properties:familyPackProperties(colors)}]})})})
.then(function(r){if(!r.ok)throw new Error('cart-add-family');return r.json()}).then(function(){return getCart(false)})
.catch(function(){toast('No se ha podido cambiar al Pack Familiar. Inténtalo de nuevo.')}).finally(function(){cartBusy=false;if(cartDrawer)cartDrawer.classList.remove('is-loading')});
}
if(cartDuoSwitchButton)cartDuoSwitchButton.addEventListener('click',function(){var id=parseInt(cartDuoSwitchButton.getAttribute('data-duo-variant-id')||0,10);if(id)replaceWithDuoPack(id)});
if(cartFamilySwitchButton)cartFamilySwitchButton.addEventListener('click',function(){var id=parseInt(cartFamilySwitchButton.getAttribute('data-family-variant-id')||0,10);if(id)replaceWithFamilyPack(id)});
if(cartPackOffers)cartPackOffers.addEventListener('click',function(e){
var btn=e.target.closest('[data-cart-pack-color]');if(!btn)return;var type=btn.getAttribute('data-cart-pack-color'),idx=parseInt(btn.getAttribute('data-pack-index')||0,10),color=normalizeColor(btn.getAttribute('data-color'));
var metrics=lastCartState?cartMetrics(lastCartState):null;if(type==='duo'){duoOfferColors[idx]=color;syncDuoOffer(metrics)}else{familyOfferColors[idx]=color;syncFamilyOffer(metrics)};
});

function renderSummary(cart,metrics){
if(cartSubtotalEl)cartSubtotalEl.textContent=money(metrics.subtotal);
if(cartDiscountRow)cartDiscountRow.hidden=!metrics.qualifies;
if(cartDiscountEl)cartDiscountEl.textContent=metrics.qualifies?'-'+money(metrics.projectedDiscount):'';
var baseTotal=metrics.qualifies?metrics.projectedTotal:(cart&&cart.total_price||metrics.subtotal);
var shipping=metrics.estimatedShipping||0;
if(cartShippingRow)cartShippingRow.hidden=false;
if(cartShippingEl){cartShippingEl.textContent=shipping?'Calculado al pagar':'Gratis';cartShippingEl.classList.remove('is-paid');cartShippingEl.classList.toggle('is-free',!shipping);}
if(cartTotalEl)cartTotalEl.textContent=money(baseTotal);
if(cartCheckout)cartCheckout.href=discountCheckoutHref(cart);
if(cartCheckoutNote){cartCheckoutNote.hidden=false;cartCheckoutNote.textContent=shipping?'Envío calculado en checkout.':'Envío gratis incluido.';}
}


function cartVariantImageByColor(color){
var match=bundleVariants.find(function(v){return v&&v.color===color&&v.image});
return match?normalizeImage(match.image):'';
}
function cartMiniImageHtml(src,alt,index){
if(!src)return '<span class="lr-cart-mini-device lr-cart-mini-device--fallback" style="--mini-index:'+index+'"></span>';
return '<span class="lr-cart-mini-device" style="--mini-index:'+index+'">'+
'<img src="'+esc(src)+'" alt="'+esc(alt)+'" loading="lazy" onerror="this.hidden=true;this.parentNode.classList.add(\'lr-cart-mini-device--fallback\')">'+
'</span>';
}
function cartMediaHtml(item,handle,options,title){
var parts=[];

/* Pack Dúo: siempre 2 Lockee reales */
if(handle===duoPackHandle){
var duoColors=options.slice(0,2);
while(duoColors.length<2)duoColors.push('Negro');
duoColors.forEach(function(color,index){
var src=cartVariantImageByColor(color);
parts.push(cartMiniImageHtml(src,'Lockee '+color,index));
});
return '<div class="lr-cart-mini-stack lr-cart-mini-stack--2" aria-label="2 Lockee">'+parts.join('')+'</div>';
}

/* Pack Familiar: siempre 3 Lockee reales */
if(handle===familyPackHandle){
var colors=options.slice(0,3);
while(colors.length<3)colors.push('Negro');

colors.forEach(function(color,index){
var src=cartVariantImageByColor(color);
parts.push(cartMiniImageHtml(src,'Lockee '+color,index));
});

return '<div class="lr-cart-mini-stack lr-cart-mini-stack--3" aria-label="3 Lockee">'+parts.join('')+'</div>';
}

/* Individual: una sola imagen. La cantidad ya está en el stepper */
if(isIndividualLockee(item)){
var color=lockeeColor(item);
var src=cartVariantImageByColor(color)||normalizeImage(item.image||item.featured_image&&item.featured_image.url||'');

if(src){
return '<img class="lr-cart-item__single-image" src="'+esc(src)+'" alt="'+esc(title)+'" loading="lazy" onerror="this.hidden=true;this.parentNode.classList.add(\'is-fallback\')">';
}
return '';
}

/* Otros productos */
var normal=normalizeImage(item.image||item.featured_image&&item.featured_image.url||'');
if(normal){
return '<img class="lr-cart-item__single-image" src="'+esc(normal)+'" alt="'+esc(title)+'" loading="lazy" onerror="this.hidden=true;this.parentNode.classList.add(\'is-fallback\')">';
}
return '';
}
function cartDisplayTitle(item,handle){
if(handle===duoPackHandle)return 'Pack Dúo';
if(handle===familyPackHandle)return 'Pack Familiar';
if(handle==='lockee'||handle==='lockee-naranja')return 'Lockee '+lockeeColor(item);
return item.product_title||item.title||'Producto';
}
function cartDisplayMeta(item,handle,options){
if(handle===duoPackHandle)return options.slice(0,2).join(' · ');
if(handle===familyPackHandle)return options.slice(0,3).join(' · ');
if(isIndividualLockee(item)){
var version=lockeeVersion(item);
return version||'';
}
return options.join(' · ');
}

function renderCart(cart){
if(!cartItemsEl)return;
lastCartState=cart;
var items=cart&&cart.items?cart.items:[];
var metrics=cartMetrics(cart);
if(cartLoadingEl)cartLoadingEl.hidden=true;
if(cartCountEl)cartCountEl.textContent=cart&&typeof cart.item_count==='number'?'('+cart.item_count+')':'';
if(cartEmptyEl)cartEmptyEl.hidden=items.length!==0;
if(cartFooter)cartFooter.hidden=items.length===0;
renderSummary(cart,metrics);
renderBundle(cart,metrics);
renderDuoSwitch(cart,metrics);
renderFamilySwitch(cart,metrics);
if(cartPackOffers)cartPackOffers.hidden=!!(cartDuoSwitch.hidden&&cartFamilySwitch.hidden);
if(!items.length){
cartItemsEl.innerHTML='';
if(cartBundle)cartBundle.hidden=true;
if(cartDuoSwitch)cartDuoSwitch.hidden=true;
if(cartFamilySwitch)cartFamilySwitch.hidden=true;
return;
}

cartItemsEl.innerHTML=items.map(function(item,index){
var handle=itemHandle(item);
var variant=(item.variant_title&&item.variant_title!=='Default Title')?item.variant_title:'';
var options=[];
if(item.options_with_values&&item.options_with_values.length){
options=item.options_with_values.map(function(o){return o&&o.value?o.value:''}).filter(Boolean);
}
if(!options.length&&variant)options=[variant];

var title=cartDisplayTitle(item,handle);
var meta=cartDisplayMeta(item,handle,options);
var mediaHtml=cartMediaHtml(item,handle,options,title);
var duoSpecHtml=handle===duoPackHandle?'<small class="lr-cart-item__duo-spec">2 Flex · 2 aperturas de emergencia cada uno</small>':'';
var familySpecHtml=handle===familyPackHandle?'<small class="lr-cart-item__family-spec">3 Flex · 2 aperturas de emergencia cada uno</small>':'';
var apertureHtml=isIndividualLockee(item)&&lockeeVersion(item)
?'<small class="lr-cart-item__apertures">'+esc(openingsLabel(lockeeVersion(item)))+'</small>'
:'';

var original=originalLinePrice(item);
var current=currentLinePrice(item);
var priceHtml='';
var shippingHtml='';

if(handle===duoPackHandle){
priceHtml='<s>'+money(duoPackCompare)+'</s>'+money(current||duoPackPrice);
shippingHtml='<small class="lr-cart-item__shipping">Envío gratis</small>';
}else if(handle===familyPackHandle){
priceHtml='<s>'+money(familyPackCompare)+'</s>'+money(current||familyPackPrice);
shippingHtml='<small class="lr-cart-item__shipping">Envío gratis</small>';
}else{
priceHtml=(original>current?'<s>'+money(original)+'</s>':'')+money(current);
if(isIndividualLockee(item)&&lockeeVersion(item)!=='Strict')shippingHtml='<small class="lr-cart-item__shipping">Envío gratis</small>';
}

return '<article class="lr-cart-item" data-cart-line="'+(index+1)+'" data-handle="'+esc(handle)+'">'+
'<div class="lr-cart-item__media">'+mediaHtml+'</div>'+
'<div class="lr-cart-item__info">'+
'<div class="lr-cart-item__top">'+
'<div class="lr-cart-item__title"><strong>'+esc(title)+'</strong>'+duoSpecHtml+familySpecHtml+(meta?'<small>'+esc(meta)+'</small>':'')+apertureHtml+shippingHtml+'</div>'+
'<span class="lr-cart-item__price">'+priceHtml+'</span>'+
'</div>'+
'<div class="lr-cart-item__actions">'+
'<div class="lr-cart-qty" aria-label="Cantidad">'+
'<button type="button" data-cart-qty="minus" aria-label="Quitar una unidad">−</button>'+
'<span>'+item.quantity+'</span>'+
'<button type="button" data-cart-qty="plus" aria-label="Añadir una unidad">+</button>'+
'</div>'+
'<button type="button" class="lr-cart-remove" data-cart-remove>Eliminar</button>'+
'</div>'+
'</div>'+
'</article>';
}).join('');
}

function getCart(openAfter){
if(cartLoadingEl)cartLoadingEl.hidden=false;
return fetch(cartUrl('cart.js'),{headers:{'Accept':'application/json'}})
.then(function(r){if(!r.ok)throw new Error('cart-fetch');return r.json()})
.then(function(cart){
renderCart(cart);
document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));
if(openAfter)openCart();
return cart;
});
}
function changeCart(line,quantity){
if(cartBusy)return;
cartBusy=true;
if(cartDrawer)cartDrawer.classList.add('is-loading');
fetch(cartUrl('cart/change.js'),{
method:'POST',
headers:{'Content-Type':'application/json','Accept':'application/json'},
body:JSON.stringify({line:line,quantity:Math.max(0,quantity)})
})
.then(function(r){if(!r.ok)throw new Error('cart-change');return r.json()})
.then(function(cart){
renderCart(cart);
document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart:cart}}));
})
.catch(function(){toast('No se ha podido actualizar el carrito.')})
.finally(function(){cartBusy=false;if(cartDrawer)cartDrawer.classList.remove('is-loading')});
}
if(cartItemsEl)cartItemsEl.addEventListener('click',function(e){
var card=e.target.closest('[data-cart-line]');
if(!card)return;
var line=parseInt(card.getAttribute('data-cart-line')||0,10);
if(!line)return;
var qtyEl=card.querySelector('.lr-cart-qty span');
var currentQty=parseInt(qtyEl&&qtyEl.textContent||1,10)||1;
var action=e.target.closest('[data-cart-qty]');
if(action){changeCart(line,currentQty+(action.getAttribute('data-cart-qty')==='plus'?1:-1));return}
if(e.target.closest('[data-cart-remove]'))changeCart(line,0);
});
function qty(){return Math.max(1,parseInt(qtyInput&&qtyInput.value||1,10)||1)}
function accessoryPrice(){return accessory&&accessoryToggle&&accessoryToggle.checked?(parseInt(accessory.getAttribute('data-accessory-price')||0,10)||0):0}
function selectedVersionName(){
var v=selectedVersionButton();
return v?(v.getAttribute('data-version-name')||''):'';
}
function syncShippingMessaging(){
var version=selectedVersionName();
var deliveryShipping=root.querySelector('[data-delivery-shipping]');
if(deliveryShipping)deliveryShipping.hidden=(version==='Strict');
}
function syncPurchase(){
var q=qty();
if(qtyInput)qtyInput.value=q;
if(qtyHidden)qtyHidden.value=q;
quickQty.forEach(function(b){var n=parseInt(b.getAttribute('data-quick-qty')||1,10);b.classList.toggle('is-selected',n===1?q===1:q>=2)});
var total=currentPrice*q+accessoryPrice();
if(price)price.textContent=money(currentPrice);
if(preview)preview.textContent=money(currentPrice*q);
if(buyPrice)buyPrice.textContent=money(total);
if(stickyPrice)stickyPrice.textContent=money(total);
if(buyBtn)buyBtn.disabled=!currentAvailable;
if(buyLabel)buyLabel.textContent=currentAvailable?'Comprar ahora':'Agotado';
syncShippingMessaging();
}
versions.forEach(function(v){v.addEventListener('click',function(){
versions.forEach(function(x){x.classList.remove('is-selected');x.setAttribute('aria-checked','false')});
v.classList.add('is-selected');v.setAttribute('aria-checked','true');
if(variantInput)variantInput.value=v.getAttribute('data-variant');
currentPrice=parseInt(v.getAttribute('data-price-cents')||0,10)||0;
currentAvailable=v.getAttribute('data-available')==='true';
cleanVariantUrl();
syncPurchase();
})});
quickQty.forEach(function(b){b.addEventListener('click',function(){if(qtyInput)qtyInput.value=b.getAttribute('data-quick-qty');syncPurchase()})});
if(qtyMinus)qtyMinus.addEventListener('click',function(){if(qtyInput)qtyInput.value=Math.max(1,qty()-1);syncPurchase()});
if(qtyPlus)qtyPlus.addEventListener('click',function(){if(qtyInput)qtyInput.value=qty()+1;syncPurchase()});
if(qtyInput)qtyInput.addEventListener('change',syncPurchase);
if(accessoryToggle)accessoryToggle.addEventListener('change',syncPurchase);
refreshVersionButtonsForColor(currentColor);
var _selectedInitial=selectedVersionButton();
if(_selectedInitial){if(variantInput)variantInput.value=_selectedInitial.getAttribute('data-variant')||'';currentPrice=parseInt(_selectedInitial.getAttribute('data-price-cents')||0,10)||0;currentAvailable=_selectedInitial.getAttribute('data-available')==='true';}
syncPurchase();
cleanVariantUrl();
function cartPayload(){
var items=[{id:parseInt(variantInput.value,10),quantity:qty()}];
if(accessory&&accessoryToggle&&accessoryToggle.checked){var aid=parseInt(accessory.getAttribute('data-accessory-id')||0,10);if(aid)items.push({id:aid,quantity:1})}
return {items:items};
}
function addItems(goCheckout){
if(!currentAvailable||!variantInput)return;
if(buyBtn)buyBtn.disabled=true;
var addBtn=form?form.querySelector('[data-add-cart]'):null;
if(addBtn)addBtn.disabled=true;
fetch(cartUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(cartPayload())})
.then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
.then(function(){
if(goCheckout){
return getCart(false).then(function(cart){
window.location.href=discountCheckoutHref(cart);
return cart;
});
}
openCart();
return getCart(false);
})
.catch(function(){toast('No se ha podido añadir. Inténtalo de nuevo.')})
.finally(function(){if(buyBtn)buyBtn.disabled=!currentAvailable;if(addBtn)addBtn.disabled=!currentAvailable});
}
if(buyBtn)buyBtn.addEventListener('click',function(){addItems(true)});
if(stickyBtn)stickyBtn.addEventListener('click',function(){addItems(true)});
if(stickyParent)stickyParent.addEventListener('click',function(){
var parentsTarget=root.querySelector('.lr-parents');
if(parentsTarget)parentsTarget.scrollIntoView({behavior:'smooth',block:'start'});
});
if(form)form.addEventListener('submit',function(e){e.preventDefault();addItems(false)});
var duoPack=root.querySelector('[data-duo-pack]');
if(duoPack){
var duoToggle=duoPack.querySelector('[data-duo-pack-toggle]');
var duoPanel=duoPack.querySelector('[data-duo-pack-panel]');
var duoClose=duoPack.querySelector('[data-duo-pack-close]');
var duoBuy=duoPack.querySelector('[data-duo-pack-buy]');
var duoBuyLabel=duoPack.querySelector('[data-duo-pack-buy-label]');
var duoMessage=duoPack.querySelector('[data-duo-pack-message]');
var duoData=duoPack.querySelector('[data-duo-pack-variants]');
var duoBlackImage=duoPack.getAttribute('data-duo-black-image')||'';
var duoOrangeImage=duoPack.getAttribute('data-duo-orange-image')||'';
var duoPdpVariants=[];
var duoBusy=false;
try{duoPdpVariants=JSON.parse(duoData&&duoData.textContent||'[]')}catch(e){duoPdpVariants=[]}
function setDuoOpen(open){
if(!duoPanel||!duoToggle)return;
duoPanel.hidden=!open;
duoToggle.setAttribute('aria-expanded',open?'true':'false');
}
function selectedDuoOptions(){
var values=[];
for(var i=1;i<=2;i++){
var selected=duoPack.querySelector('[data-duo-pack-color][data-position="'+i+'"].is-selected');
values.push(selected?selected.getAttribute('data-value'):'');
}
return values;
}
function selectedDuoVariant(){
var options=selectedDuoOptions();
return duoPdpVariants.find(function(v){return v&&v.options&&v.options[0]===options[0]&&v.options[1]===options[1]})||null;
}
function duoImageForColor(color){return color==='Naranja'?duoOrangeImage:duoBlackImage;}
function syncDuoVisuals(){
var options=selectedDuoOptions();
for(var i=1;i<=2;i++){
var color=options[i-1]||'Negro';
var src=duoImageForColor(color);
var summaryImg=duoPack.querySelector('[data-duo-pack-device="'+i+'"] [data-duo-pack-device-img]');
var optionImg=duoPack.querySelector('[data-duo-pack-option-device="'+i+'"] [data-duo-pack-option-img]');
if(summaryImg&&src)summaryImg.src=src;
if(optionImg&&src)optionImg.src=src;
}
}
function syncDuoPack(){
syncDuoVisuals();
var variant=selectedDuoVariant();
if(!duoBuy)return variant;
if(duoBusy){duoBuy.disabled=true;return variant;}
if(!variant){duoBuy.disabled=true;if(duoBuyLabel)duoBuyLabel.textContent='Combinación no disponible';if(duoMessage)duoMessage.textContent='No encontramos esta combinación.';return null;}
if(!variant.available){duoBuy.disabled=true;if(duoBuyLabel)duoBuyLabel.textContent='Combinación agotada';if(duoMessage)duoMessage.textContent='Esta combinación está agotada ahora mismo.';return variant;}
duoBuy.disabled=false;
if(duoBuyLabel)duoBuyLabel.textContent='Añadir Pack Dúo';
if(duoMessage)duoMessage.textContent='';
return variant;
}
if(duoToggle)duoToggle.addEventListener('click',function(){setDuoOpen(duoPanel?!!duoPanel.hidden:false)});
if(duoClose)duoClose.addEventListener('click',function(){setDuoOpen(false);if(duoToggle)duoToggle.focus()});
duoPack.querySelectorAll('[data-duo-pack-color]').forEach(function(btn){btn.addEventListener('click',function(){
var pos=btn.getAttribute('data-position');
duoPack.querySelectorAll('[data-duo-pack-color][data-position="'+pos+'"]').forEach(function(other){var active=other===btn;other.classList.toggle('is-selected',active);other.setAttribute('aria-pressed',active?'true':'false')});
syncDuoPack();
})});
if(duoBuy)duoBuy.addEventListener('click',function(){
var variant=syncDuoPack();
if(!variant||!variant.available||duoBusy)return;
duoBusy=true;
duoBuy.disabled=true;
if(duoBuyLabel)duoBuyLabel.textContent='Añadiendo…';
if(duoMessage)duoMessage.textContent='';
fetch(cartUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(variant.id,10),quantity:1,properties:duoPackProperties(selectedDuoOptions())}]})})
.then(function(r){if(!r.ok)return r.json().then(function(data){throw new Error(data&&data.description?data.description:'cart')});return r.json()})
.then(function(){openCart();return getCart(false)})
.then(function(){toast('Pack Dúo añadido al carrito.')})
.catch(function(err){if(duoMessage)duoMessage.textContent=err&&err.message&&err.message!=='cart'?err.message:'No se ha podido añadir el pack. Inténtalo de nuevo.'})
.finally(function(){duoBusy=false;syncDuoPack()});
});
syncDuoPack();
}
var familyPack=root.querySelector('[data-family-pack]');
if(familyPack){
var familyToggle=familyPack.querySelector('[data-family-pack-toggle]');
var familyPanel=familyPack.querySelector('[data-family-pack-panel]');
var familyClose=familyPack.querySelector('[data-family-pack-close]');
var familyBuy=familyPack.querySelector('[data-family-pack-buy]');
var familyBuyLabel=familyPack.querySelector('[data-family-pack-buy-label]');
var familyMessage=familyPack.querySelector('[data-family-pack-message]');
var familyData=familyPack.querySelector('[data-family-pack-variants]');
var familyBlackImage=familyPack.getAttribute('data-family-black-image')||'';
var familyOrangeImage=familyPack.getAttribute('data-family-orange-image')||'';
var familyVariants=[];
var familyBusy=false;
try{familyVariants=JSON.parse(familyData&&familyData.textContent||'[]')}catch(e){familyVariants=[]}
function setFamilyOpen(open){
if(!familyPanel||!familyToggle)return;
familyPanel.hidden=!open;
familyToggle.setAttribute('aria-expanded',open?'true':'false');
}
function selectedFamilyOptions(){
var values=[];
for(var i=1;i<=3;i++){
var selected=familyPack.querySelector('[data-family-pack-color][data-position="'+i+'"].is-selected');
values.push(selected?selected.getAttribute('data-value'):'');
}
return values;
}
function selectedFamilyVariant(){
var options=selectedFamilyOptions();
return familyVariants.find(function(v){return v&&v.options&&v.options[0]===options[0]&&v.options[1]===options[1]&&v.options[2]===options[2]})||null;
}
function familyImageForColor(color){
return color==='Naranja'?familyOrangeImage:familyBlackImage;
}
function syncFamilyVisuals(){
var options=selectedFamilyOptions();
for(var i=1;i<=3;i++){
var color=options[i-1]||'Negro';
var src=familyImageForColor(color);
var summaryImg=familyPack.querySelector('[data-family-pack-device="'+i+'"] [data-family-pack-device-img]');
var optionImg=familyPack.querySelector('[data-family-pack-option-device="'+i+'"] [data-family-pack-option-img]');
if(summaryImg&&src)summaryImg.src=src;
if(optionImg&&src)optionImg.src=src;
}
}
function syncFamilyPack(){
syncFamilyVisuals();
var variant=selectedFamilyVariant();
if(!familyBuy)return variant;
if(familyBusy){familyBuy.disabled=true;return variant}
if(!variant){familyBuy.disabled=true;if(familyBuyLabel)familyBuyLabel.textContent='Combinación no disponible';if(familyMessage)familyMessage.textContent='No encontramos esta combinación.';return null}
if(!variant.available){familyBuy.disabled=true;if(familyBuyLabel)familyBuyLabel.textContent='Combinación agotada';if(familyMessage)familyMessage.textContent='Esta combinación está agotada ahora mismo.';return variant}
familyBuy.disabled=false;
if(familyBuyLabel)familyBuyLabel.textContent='Añadir Pack Familiar';
if(familyMessage)familyMessage.textContent='';
return variant;
}
if(familyToggle)familyToggle.addEventListener('click',function(){setFamilyOpen(familyPanel?!!familyPanel.hidden:false)});
if(familyClose)familyClose.addEventListener('click',function(){setFamilyOpen(false);if(familyToggle)familyToggle.focus()});
familyPack.querySelectorAll('[data-family-pack-color]').forEach(function(btn){btn.addEventListener('click',function(){
var pos=btn.getAttribute('data-position');
familyPack.querySelectorAll('[data-family-pack-color][data-position="'+pos+'"]').forEach(function(other){var active=other===btn;other.classList.toggle('is-selected',active);other.setAttribute('aria-pressed',active?'true':'false')});
syncFamilyPack();
})});
if(familyBuy)familyBuy.addEventListener('click',function(){
var variant=syncFamilyPack();
if(!variant||!variant.available||familyBusy)return;
familyBusy=true;
familyBuy.disabled=true;
if(familyBuyLabel)familyBuyLabel.textContent='Añadiendo…';
if(familyMessage)familyMessage.textContent='';
fetch(cartUrl('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(variant.id,10),quantity:1,properties:familyPackProperties(selectedFamilyOptions())}]})})
.then(function(r){if(!r.ok)return r.json().then(function(data){throw new Error(data&&data.description?data.description:'cart')});return r.json()})
.then(function(){openCart();return getCart(false)})
.then(function(){toast('Pack Familiar añadido al carrito.')})
.catch(function(err){if(familyMessage)familyMessage.textContent=err&&err.message&&err.message!=='cart'?err.message:'No se ha podido añadir el pack. Inténtalo de nuevo.'})
.finally(function(){familyBusy=false;syncFamilyPack()});
});
syncFamilyPack();
}
var delivery=root.querySelector('[data-delivery]');
if(delivery){
var out=delivery.querySelector('[data-delivery-range]');
var min=parseInt(delivery.getAttribute('data-min')||2,10),max=parseInt(delivery.getAttribute('data-max')||4,10);
function addBusinessDays(date,days){var d=new Date(date);while(days>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)days--}return d}
var now=new Date(),a=addBusinessDays(now,min),b=addBusinessDays(now,max);
var fmt=new Intl.DateTimeFormat('es-ES',{weekday:'short',day:'numeric',month:'short'});
if(out)out.textContent=fmt.format(a)+' – '+fmt.format(b);
}
var gallery=root.querySelector('[data-gallery]');
if(gallery){
var stage=gallery.querySelector('[data-gallery-stage]'),allSlides=Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]')),allThumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]')),prev=gallery.querySelector('[data-gallery-prev]'),next=gallery.querySelector('[data-gallery-next]'),expand=gallery.querySelector('[data-gallery-expand]');
var activeSlides=[],activeThumbs=[],index=0,mq=window.matchMedia('(max-width:760px)'),startX=0,startY=0,startIndex=0,moved=false;
function mobile(){return mq.matches}
function ratio(s){return parseFloat(s&&s.getAttribute('data-ratio')||1)||1}
function mediaColor(el){return normalizeColor(el&&el.getAttribute('data-media-color')==='Naranja'?'Naranja':(el&&el.getAttribute('data-media-color')==='Negro'?'Negro':'Todos'))}
function matchesColor(el,color){var raw=el&&el.getAttribute('data-media-color')||'Todos';return raw==='Todos'||normalizeColor(raw)===normalizeColor(color)}
function sizeStage(i){
  if(!stage||!activeSlides[i])return;
  var r=ratio(activeSlides[i]);
  if(mobile()){stage.style.aspectRatio='auto';stage.style.height=Math.round(stage.clientWidth/r)+'px'}
  else{stage.style.height='';stage.style.aspectRatio=String(r)}
}
function sync(i,animate){
  if(!activeSlides.length)return;
  i=Math.max(0,Math.min(activeSlides.length-1,i));index=i;
  allSlides.forEach(function(s){s.classList.remove('is-active');s.querySelectorAll('video[data-lazy-gallery-video]').forEach(function(v){try{v.pause()}catch(e){}})});
  allThumbs.forEach(function(t){t.classList.remove('is-active')});
  var slide=activeSlides[i];
  var thumb=activeThumbs[i];
  if(slide){slide.classList.add('is-active');slide.querySelectorAll('video[data-lazy-gallery-video]').forEach(function(v){if(window.AYLUHydrateVideo)window.AYLUHydrateVideo(v);v.muted=true;try{var p=v.play();if(p&&p.catch)p.catch(function(){})}catch(e){}})}
  if(thumb)thumb.classList.add('is-active');
  sizeStage(i);
  if(mobile()&&stage){var left=i*stage.clientWidth;stage.scrollTo({left:left,behavior:animate?'smooth':'auto'})}
}
function rebuildLightbox(){if(track){track.innerHTML=''}built=false}
function applyGalleryColor(color,fromInit){
  activeSlides=[];activeThumbs=[];
  allSlides.forEach(function(s){var show=matchesColor(s,color);s.setAttribute('data-color-hidden',show?'false':'true');if(show)activeSlides.push(s)});
  activeSlides.forEach(function(s){var idx=s.getAttribute('data-index');var t=allThumbs.find(function(x){return x.getAttribute('data-index')===idx});if(t)activeThumbs.push(t)});
  allThumbs.forEach(function(t){var show=activeThumbs.indexOf(t)!==-1;t.setAttribute('data-color-hidden',show?'false':'true')});
  rebuildLightbox();
  var preferred=activeSlides.length>1?1:0;
  if(fromInit){
    var absolute=parseInt(gallery.getAttribute('data-current')||0,10)||0;
    var found=activeSlides.findIndex(function(s){return parseInt(s.getAttribute('data-index')||-1,10)===absolute});
    if(found>=0)preferred=found;
  }
  index=preferred;
  if(stage)stage.scrollLeft=0;
  sync(index,false);
  var mobileLcp=gallery.querySelector('[data-mobile-gallery-lcp]');
  if(mobileLcp&&mobile()){requestAnimationFrame(function(){requestAnimationFrame(function(){mobileLcp.classList.add('is-hidden');setTimeout(function(){if(mobileLcp&&mobileLcp.parentNode)mobileLcp.parentNode.removeChild(mobileLcp)},180)})})}else if(mobileLcp){mobileLcp.remove()}
}
galleryColorApply=applyGalleryColor;
if(prev)prev.addEventListener('click',function(){sync(index<=0?activeSlides.length-1:index-1,true)});
if(next)next.addEventListener('click',function(){sync(index>=activeSlides.length-1?0:index+1,true)});
allThumbs.forEach(function(t){t.addEventListener('click',function(){var idx=activeThumbs.indexOf(t);if(idx>=0)sync(idx,true)})});
if(stage){
  stage.addEventListener('touchstart',function(e){if(!mobile())return;var t=e.touches[0];startX=t.clientX;startY=t.clientY;startIndex=index;moved=false},{passive:true});
  stage.addEventListener('touchmove',function(e){if(!mobile())return;var t=e.touches[0],dx=t.clientX-startX,dy=t.clientY-startY;if(Math.abs(dx)>8||Math.abs(dy)>8)moved=true;if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>5)e.preventDefault()},{passive:false});
  stage.addEventListener('touchend',function(e){if(!mobile())return;var t=e.changedTouches[0],dx=t.clientX-startX,dy=t.clientY-startY;if(Math.abs(dx)>42&&Math.abs(dx)>Math.abs(dy))sync(startIndex+(dx<0?1:-1),true);else sync(startIndex,true)},{passive:true});
}
if(mq.addEventListener)mq.addEventListener('change',function(){sync(index,false)});
window.addEventListener('resize',function(){if(mobile())sync(index,false)});
var lb=gallery.querySelector('[data-lightbox]'),track=gallery.querySelector('[data-lightbox-track]'),count=gallery.querySelector('[data-lightbox-count]'),close=gallery.querySelector('[data-lightbox-close]'),built=false,lbIndex=0;
function build(){if(built||!track)return;activeSlides.forEach(function(s){var c=document.createElement('div');c.className='lr-lb-slide';var m=s.querySelector('img,video,iframe');if(m){var clone=m.cloneNode(true);clone.removeAttribute('autoplay');if(m.tagName&&m.tagName.toLowerCase()==='img'){var src=m.currentSrc||m.getAttribute('src')||'';if(src){c.classList.add('has-image');c.style.setProperty('--lr-lb-bg','url("'+src.replace(/"/g,'\"')+'")')}}c.appendChild(clone)}track.appendChild(c)});built=true}
function updateLb(){if(count)count.textContent=(lbIndex+1)+' / '+activeSlides.length}
function openLb(i){if(!lb||!activeSlides.length)return;build();lbIndex=Math.max(0,Math.min(activeSlides.length-1,i));lb.hidden=false;lb.classList.add('is-open');lb.setAttribute('aria-hidden','false');document.body.classList.add('lr-locked');var lv=track&&track.children[lbIndex]?track.children[lbIndex].querySelector('video'):null;if(lv&&window.AYLUHydrateVideo)window.AYLUHydrateVideo(lv);requestAnimationFrame(function(){track.scrollLeft=lbIndex*track.clientWidth;updateLb()})}
function closeLb(){if(!lb)return;lb.classList.remove('is-open');lb.hidden=true;document.body.classList.remove('lr-locked');sync(lbIndex,false)}
if(expand)expand.addEventListener('click',function(){openLb(index)});
allSlides.forEach(function(s){var img=s.querySelector('img');if(img)img.addEventListener('click',function(){if(mobile()&&!moved){var i=activeSlides.indexOf(s);if(i>=0)openLb(i)}})});
if(close)close.addEventListener('click',closeLb);
if(track)track.addEventListener('scroll',function(){clearTimeout(track._t);track._t=setTimeout(function(){if(track.clientWidth){lbIndex=Math.round(track.scrollLeft/track.clientWidth);var lv=track.children[lbIndex]?track.children[lbIndex].querySelector('video'):null;if(lv&&window.AYLUHydrateVideo)window.AYLUHydrateVideo(lv);updateLb()}},70)},{passive:true});
document.addEventListener('keydown',function(e){if(lb&&!lb.hidden&&e.key==='Escape')closeLb()});
applyProductColor(currentColor,true);
}
var action=root.querySelector('[data-action-scenes]');
if(action){
var radios=Array.prototype.slice.call(action.querySelectorAll('.lr-scene-radio')),
labels=Array.prototype.slice.call(action.querySelectorAll('[data-scene-label], [data-mobile-scene-label]')),
scenes=Array.prototype.slice.call(action.querySelectorAll('[data-scene-slot]'));
function sceneBySlot(slot){return action.querySelector('[data-scene-slot="'+slot+'"]')}
function warmVideo(slot){
var scene=sceneBySlot(slot);if(!scene)return;
scene.querySelectorAll('video').forEach(function(video){
if(window.AYLUHydrateVideo)window.AYLUHydrateVideo(video);video.muted=true;video.setAttribute('muted','');video.setAttribute('playsinline','');video.preload='metadata';
});
}
function playScene(slot,restart){
scenes.forEach(function(scene){
var active=scene.getAttribute('data-scene-slot')===String(slot);
scene.querySelectorAll('video').forEach(function(video){
var btn=scene.querySelector('[data-scene-play-toggle] span');
if(active){
if(window.AYLUHydrateVideo)window.AYLUHydrateVideo(video);video.muted=true;video.setAttribute('muted','');video.setAttribute('playsinline','');
if(restart){try{video.currentTime=0}catch(e){}}
var start=function(){
var p;try{p=video.play()}catch(e){}
if(p&&p.catch)p.catch(function(){try{video.load()}catch(e){};setTimeout(function(){try{var p2=video.play();if(p2&&p2.catch)p2.catch(function(){})}catch(e){}},45)});
};
start();requestAnimationFrame(function(){requestAnimationFrame(start)});
if(btn)btn.textContent='Ⅱ';
}else{try{video.pause()}catch(e){};if(btn)btn.textContent='▶'}
});
});
}
labels.forEach(function(label){
var slot=label.getAttribute('data-scene-label')||label.getAttribute('data-mobile-scene-label');
['pointerenter','touchstart','pointerdown'].forEach(function(evt){label.addEventListener(evt,function(){warmVideo(slot)},{passive:true})});
label.addEventListener('click',function(){playScene(slot,true);setTimeout(function(){playScene(slot,false)},0)});
});
radios.forEach(function(radio){radio.addEventListener('change',function(){if(radio.checked)playScene(radio.getAttribute('data-scene-radio'),true)})});
action.querySelectorAll('[data-scene-play-toggle]').forEach(function(btn){
btn.addEventListener('click',function(e){
e.preventDefault();e.stopPropagation();
var scene=btn.closest('[data-scene-slot]'),video=scene&&scene.querySelector('video'),icon=btn.querySelector('span');
if(!video)return;
if(video.paused){var p=video.play();if(p&&p.catch)p.catch(function(){});if(icon)icon.textContent='Ⅱ'}
else{video.pause();if(icon)icon.textContent='▶'}
});
});
var checked=action.querySelector('.lr-scene-radio:checked');if(checked){
var initialSlot=checked.getAttribute('data-scene-radio');
if('IntersectionObserver' in window){
var actionOpts=lrMobilePerf?{rootMargin:'0px',threshold:[.45]}:{rootMargin:'400px 0px',threshold:.01};
var actionLoader=new IntersectionObserver(function(entries){entries.forEach(function(entry){var ready=lrMobilePerf?(entry.isIntersecting&&entry.intersectionRatio>=.45):entry.isIntersecting;if(ready){playScene(initialSlot,false);actionLoader.disconnect()}})},actionOpts);
actionLoader.observe(action)
}else if(!lrMobilePerf){playScene(initialSlot,false)}
}
}
var singleResultVideo=root.querySelector('.lr-single-result-video__media');
if(singleResultVideo){
singleResultVideo.muted=true;
singleResultVideo.defaultMuted=true;
singleResultVideo.setAttribute('muted','');
singleResultVideo.setAttribute('playsinline','');
singleResultVideo.loop=true;
var startSingleResult=function(restart){
try{
if(restart)singleResultVideo.currentTime=0;
var p=singleResultVideo.play();
if(p&&p.catch)p.catch(function(){});
}catch(e){}
};
if('IntersectionObserver' in window){
var singleResultObserver=new IntersectionObserver(function(entries){
entries.forEach(function(entry){
if(entry.isIntersecting && entry.intersectionRatio>.35){
startSingleResult(true);
}else{
try{singleResultVideo.pause()}catch(e){}
}
});
},{threshold:[0,.35,.7]});
singleResultObserver.observe(singleResultVideo);
}else{
startSingleResult(false);
}
}
var resultScroll=root.querySelector('[data-scroll-results]');
if(resultScroll){var scenes=Array.prototype.slice.call(resultScroll.querySelectorAll('[data-result-scene]')),dots=Array.prototype.slice.call(resultScroll.querySelectorAll('.lr-results-progress i')),activeResult=-1,rafResult=0;function setResult(i){if(!scenes.length)return;i=Math.max(0,Math.min(scenes.length-1,i));if(i===activeResult)return;activeResult=i;scenes.forEach(function(scene,n){scene.classList.toggle('is-active',n===i)});dots.forEach(function(dot,n){dot.classList.toggle('is-active',n===i)})}function updateResults(){rafResult=0;var rect=resultScroll.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight,traveled=Math.max(0,Math.min(resultScroll.offsetHeight-vh,-rect.top)),i=Math.floor(traveled/vh);setResult(i)}function queueResults(){if(rafResult)return;rafResult=requestAnimationFrame(updateResults)}window.addEventListener('scroll',queueResults,{passive:true});window.addEventListener('resize',queueResults);setResult(0);updateResults()}
var stories=root.querySelector('[data-story-carousel]');
if(stories){var tr=stories.querySelector('[data-story-track]'),sp=stories.querySelector('[data-story-prev]'),sn=stories.querySelector('[data-story-next]');function storyMove(dir){if(!tr)return;var card=tr.querySelector('.lr-story');var step=card?card.getBoundingClientRect().width+14:window.innerWidth*.8;tr.scrollBy({left:dir*step,behavior:'smooth'})}if(sp)sp.addEventListener('click',function(){storyMove(-1)});if(sn)sn.addEventListener('click',function(){storyMove(1)})}
function detailBody(item){return item.querySelector(':scope > div')}
function detailIcon(item){return item.querySelector('summary span, summary i')}
function setDetailIcon(item,open){var icon=detailIcon(item);if(icon&&(icon.textContent==='⌄'||icon.textContent==='⌃'))icon.textContent=open?'⌃':'⌄'}
function animateDetailClose(item,done){if(!item||!item.open){if(done)done();return}var body=detailBody(item);if(!body){item.open=false;setDetailIcon(item,false);if(done)done();return}body.style.overflow='hidden';body.style.height=body.scrollHeight+'px';body.style.opacity='1';body.getBoundingClientRect();body.style.transition='height 220ms cubic-bezier(.4,0,.2,1), opacity 160ms ease';body.style.height='0px';body.style.opacity='0';window.setTimeout(function(){item.open=false;setDetailIcon(item,false);body.style.removeProperty('height');body.style.removeProperty('opacity');body.style.removeProperty('overflow');body.style.removeProperty('transition');if(done)done()},230)}
function animateDetailOpen(item){if(!item)return;var body=detailBody(item);item.open=true;setDetailIcon(item,true);if(!body)return;body.style.overflow='hidden';body.style.height='0px';body.style.opacity='0';body.getBoundingClientRect();var target=body.scrollHeight;body.style.transition='height 260ms cubic-bezier(.2,.75,.2,1), opacity 200ms ease 35ms';requestAnimationFrame(function(){body.style.height=target+'px';body.style.opacity='1'});window.setTimeout(function(){body.style.removeProperty('height');body.style.removeProperty('opacity');body.style.removeProperty('overflow');body.style.removeProperty('transition')},285)}
root.querySelectorAll('[data-exclusive-details]').forEach(function(group){var items=Array.prototype.slice.call(group.querySelectorAll(':scope > details'));items.forEach(function(item){var summary=item.querySelector(':scope > summary');setDetailIcon(item,item.open);if(!summary)return;summary.addEventListener('click',function(e){e.preventDefault();if(group.dataset.animating==='1')return;if(item.open){group.dataset.animating='1';animateDetailClose(item,function(){group.dataset.animating='0'});return}var current=items.find(function(other){return other!==item&&other.open});if(current){group.dataset.animating='1';animateDetailClose(current,function(){window.setTimeout(function(){animateDetailOpen(item);window.setTimeout(function(){group.dataset.animating='0'},290)},55)})}else{group.dataset.animating='1';animateDetailOpen(item);window.setTimeout(function(){group.dataset.animating='0'},290)}})})});
root.querySelectorAll('[data-screen-time-calc]').forEach(function(calc){
if(lrMobilePerf&&calc.closest('.lr-desktop-v6-only'))return;
var hoursInput=calc.querySelector('[data-time-hours-input]');
var minutesInput=calc.querySelector('[data-time-minutes-input]');
var rangeInput=calc.querySelector('[data-time-range]');
var rangeLabel=calc.querySelector('[data-time-range-label]');
var daysOut=calc.querySelector('[data-time-days]');
var yearPctOut=calc.querySelector('[data-year-percentage]');
var monthsCopy=calc.querySelector('[data-time-months-copy]');
var calendarMonths=Array.prototype.slice.call(calc.querySelectorAll('[data-calendar-month]'));
var awakeScreenDuration=calc.querySelector('[data-awake-screen-duration]');
var awakeRemainingDuration=calc.querySelector('[data-awake-remaining-duration]');
var awakeRemainingBig=calc.querySelector('[data-awake-remaining-big]');
var awakePctOut=calc.querySelector('[data-awake-screen-percentage]');
var awakeOneIn=calc.querySelector('[data-awake-one-in]');
var awakeScreenCopy=calc.querySelector('[data-awake-screen-copy]');
var sleepSeg=calc.querySelector('[data-day-sleep]');
var screenSeg=calc.querySelector('[data-day-screen]');
var lifeSeg=calc.querySelector('[data-day-life]');
var awakeSection=calc.querySelector('[data-awake-impact]');
var lifetime=calc.querySelector('[data-lifetime-impact]');
var selectedYearsValue=calc.querySelector('[data-selected-years-value]');
var selectedYearsLabel=calc.querySelector('[data-selected-years-label]');
var yearTabs=Array.prototype.slice.call(calc.querySelectorAll('[data-years-tab]'));
var recoveryBlock=calc.querySelector('[data-recovery-block]');
var recoveryLabel=calc.querySelector('[data-recovery-label]');
var recoveryDays=calc.querySelector('[data-recovery-days]');
var recoveryHours=calc.querySelector('[data-recovery-hours]');
if(!hoursInput || !minutesInput || !daysOut)return;
var lifeCarousel=calc.querySelector('[data-life-carousel]');
var lifeDots=calc.querySelector('[data-life-dots]');
if(lifeCarousel && lifeDots){
var lifeSlides=Array.prototype.slice.call(lifeCarousel.children).filter(function(el){return el.tagName==='SECTION'});
var lifeDotButtons=[];
lifeSlides.forEach(function(slide,i){
var dot=document.createElement('button');
dot.type='button';
dot.setAttribute('aria-label','Ver resultado '+(i+1)+' de '+lifeSlides.length);
if(i===0)dot.classList.add('is-active');
dot.addEventListener('click',function(){
lifeCarousel.scrollTo({left:Math.max(0,slide.offsetLeft-16),behavior:'smooth'});
});
lifeDots.appendChild(dot);
lifeDotButtons.push(dot);
});
var lifeDotRaf=0;
function syncLifeDots(){
lifeDotRaf=0;
if(!lifeSlides.length)return;
var target=lifeCarousel.scrollLeft+(lifeCarousel.clientWidth*.46);
var active=0,best=Infinity;
lifeSlides.forEach(function(slide,i){
var center=slide.offsetLeft+(slide.offsetWidth/2);
var d=Math.abs(center-target);
if(d<best){best=d;active=i}
});
lifeDotButtons.forEach(function(dot,i){dot.classList.toggle('is-active',i===active)});
}
lifeCarousel.addEventListener('scroll',function(){
if(lifeDotRaf)return;
lifeDotRaf=requestAnimationFrame(syncLifeDots);
},{passive:true});
window.addEventListener('resize',syncLifeDots);
syncLifeDots();
}
var prefersReduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var latest={dailyMinutes:270,daysPerYear:68.4,yearPct:18.8};
var animatedOnce=false;
function clamp(n,min,max){n=parseInt(n,10);if(isNaN(n))n=0;return Math.max(min,Math.min(max,n))}
function fmt1(n){return (Math.round(n*10)/10).toFixed(1).replace('.',',')}
function durationText(minutes){
minutes=Math.max(0,Math.round(minutes));
var h=Math.floor(minutes/60),m=minutes%60;
if(h && m)return h+' h '+m+' min';
if(h)return h+' h';
return m+' min';
}
function animateValue(el,to,duration){
if(!el)return;
if(prefersReduced || !duration){el.textContent=fmt1(to);el.dataset.num=to;return}
var from=parseFloat(el.dataset.num||String(to).replace(',','.'));
if(isNaN(from))from=0;
var start=performance.now();
function frame(now){
var t=Math.min(1,(now-start)/duration),e=1-Math.pow(1-t,3);
var value=from+(to-from)*e;
el.textContent=fmt1(value);
if(t<1)requestAnimationFrame(frame);else el.dataset.num=to;
}
requestAnimationFrame(frame);
}
function updateCalendar(daysPerYear,animate){
if(!calendarMonths.length)return;
var monthDays=[31,28,31,30,31,30,31,31,30,31,30,31];
var remaining=Math.max(0,Math.min(365,daysPerYear));
calendarMonths.forEach(function(monthEl,index){
var total=monthDays[index];
var used=Math.max(0,Math.min(total,remaining));
remaining-=used;
var fill=monthEl.querySelector('[data-calendar-fill]');
var label=monthEl.querySelector('[data-calendar-label]');
var pct=total?(used/total)*100:0;
monthEl.classList.toggle('is-full',used>=total-.01);
monthEl.classList.toggle('is-partial',used>0&&used<total-.01);
if(label){
if(used>=total-.01)label.textContent='Completo';
else if(used>=.5)label.textContent=Math.round(used)+' días';
else label.textContent='';
}
if(fill){
if(animate && !prefersReduced){fill.style.height='0%';setTimeout(function(){fill.style.height=pct+'%'},index*35+50)}
else fill.style.height=pct+'%';
}
});
}
function updateLifetime(animate){
if(!lifetime||!selectedYearsValue||!selectedYearsLabel)return;
var years=parseInt(lifetime.dataset.selectedYears||'30',10)||30;
var awakeMinutes=16*60;
var lost=(Math.min(latest.dailyMinutes,awakeMinutes)/awakeMinutes)*years;
selectedYearsLabel.textContent=years+' años';
animateValue(selectedYearsValue,lost,animate?650:0);
yearTabs.forEach(function(btn){
var active=parseInt(btn.dataset.yearsTab,10)===years;
btn.classList.toggle('is-active',active);
btn.setAttribute('aria-selected',active?'true':'false');
});
}
function update(animate){
var h=clamp(hoursInput.value,0,24);
var m=clamp(minutesInput.value,0,59);
if(h>=24){h=24;m=0}
hoursInput.value=h;minutesInput.value=m;
var dailyMinutes=Math.min(1440,(h*60)+m);
var daysPerYear=(dailyMinutes*365)/1440;
var yearPct=(daysPerYear/365)*100;
var monthsEquivalent=daysPerYear/(365/12);
var awakeMinutes=16*60;
var awakeScreenMinutes=Math.min(dailyMinutes,awakeMinutes);
var remaining=Math.max(0,awakeMinutes-awakeScreenMinutes);
var awakePct=awakeMinutes?(awakeScreenMinutes/awakeMinutes)*100:0;
latest={dailyMinutes:dailyMinutes,daysPerYear:daysPerYear,yearPct:yearPct};
if(recoveryBlock){
var reducibleMinutes=Math.min(60,dailyMinutes);
if(dailyMinutes<=0){
recoveryBlock.classList.add('is-empty');
if(recoveryLabel)recoveryLabel.textContent='MUEVE EL SLIDER PARA VER LO QUE PODRÍAS RECUPERAR';
if(recoveryDays)recoveryDays.textContent='0,0';
if(recoveryHours)recoveryHours.textContent='0';
}else{
recoveryBlock.classList.remove('is-empty');
if(recoveryLabel)recoveryLabel.textContent=reducibleMinutes>=60?'SI REDUJERAS SOLO 1 HORA AL DÍA':'SI REDUJERAS '+durationText(reducibleMinutes).toUpperCase()+' AL DÍA';
var recoveredDays=(reducibleMinutes*365)/1440;
var recoveredHours=(reducibleMinutes*365)/60;
if(recoveryDays)recoveryDays.textContent=fmt1(recoveredDays);
if(recoveryHours)recoveryHours.textContent=Math.round(recoveredHours).toLocaleString('es-ES');
}
}
if(rangeInput){
var rv=Math.max(0,Math.min(1440,dailyMinutes));
rangeInput.value=rv;
if(rangeLabel)rangeLabel.textContent=durationText(rv);
var rp=(rv/1440)*100;
rangeInput.style.background='linear-gradient(to right,var(--lr-accent) 0%,var(--lr-accent) '+rp+'%,#e7e3dd '+rp+'%,#e7e3dd 100%)';
}
animateValue(daysOut,daysPerYear,animate?700:0);
if(yearPctOut)yearPctOut.textContent=fmt1(yearPct)+' %';
if(monthsCopy){
var fullMonths=Math.floor(monthsEquivalent);
if(fullMonths>=1)monthsCopy.textContent='Más de '+fullMonths+' '+(fullMonths===1?'mes':'meses')+' mirando una pantalla.';
else monthsCopy.textContent=fmt1(daysPerYear)+' días mirando una pantalla.';
}
updateCalendar(daysPerYear,animate);
var screenForVisual=awakeScreenMinutes;
var sleepWidth=(8/24)*100;
var screenWidth=(screenForVisual/1440)*100;
var lifeWidth=(remaining/1440)*100;
var drawDayBar=!calc.classList.contains('is-motion-ready')||(awakeSection&&awakeSection.classList.contains('is-inview'));
if(drawDayBar){
if(sleepSeg)sleepSeg.style.width=sleepWidth+'%';
if(screenSeg)screenSeg.style.width=screenWidth+'%';
if(lifeSeg)lifeSeg.style.width=lifeWidth+'%';
}
var screenText=durationText(dailyMinutes),remainingText=durationText(remaining);
if(awakeScreenDuration)awakeScreenDuration.textContent=screenText;
if(awakeRemainingDuration)awakeRemainingDuration.textContent=remainingText;
if(awakeRemainingBig)awakeRemainingBig.textContent=remainingText;
if(awakePctOut)awakePctOut.textContent=fmt1(awakePct)+' %';
if(awakeOneIn){
if(dailyMinutes<=0){
awakeOneIn.textContent='La pantalla no ocupa tiempo de tus horas despierto';
}else if(dailyMinutes>=awakeMinutes){
awakeOneIn.textContent='La pantalla ocupa todas tus horas despierto';
}else{
var oneIn=awakeMinutes/dailyMinutes;
awakeOneIn.textContent='1 de cada '+fmt1(oneIn)+' horas despierto';
}
}
if(awakeScreenCopy)awakeScreenCopy.textContent=screenText;
updateLifetime(animate&&(!calc.classList.contains('is-motion-ready')||(lifetime&&lifetime.classList.contains('is-inview'))));
}
yearTabs.forEach(function(btn){btn.addEventListener('click',function(){if(lifetime)lifetime.dataset.selectedYears=btn.dataset.yearsTab;updateLifetime(true)})});
if(rangeInput)rangeInput.addEventListener('input',function(){var total=clamp(rangeInput.value,0,1440);hoursInput.value=Math.floor(total/60);minutesInput.value=total%60;if(total===1440){hoursInput.value=24;minutesInput.value=0}update(true)});
hoursInput.addEventListener('input',function(){update(true)});
minutesInput.addEventListener('input',function(){update(true)});
update(false);
if(!prefersReduced && 'IntersectionObserver' in window){
calc.classList.add('is-motion-ready');
if(sleepSeg)sleepSeg.style.width='0%';
if(screenSeg)screenSeg.style.width='0%';
if(lifeSeg)lifeSeg.style.width='0%';
calendarMonths.forEach(function(monthEl){var fill=monthEl.querySelector('[data-calendar-fill]');if(fill)fill.style.height='0%'});
var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){
if(entry.isIntersecting){
entry.target.classList.add('is-inview');
if(entry.target.classList.contains('lr-annual-impact')&&!animatedOnce){
animatedOnce=true;
daysOut.dataset.num='0';
update(true);
}else if(entry.target===awakeSection){
update(true);
}else if(entry.target===lifetime){
if(selectedYearsValue)selectedYearsValue.dataset.num='0';
updateLifetime(true);
}
observer.unobserve(entry.target);
}
})},{threshold:.2});
calc.querySelectorAll('[data-animate-section]').forEach(function(el){observer.observe(el)});
}else{
calc.querySelectorAll('[data-animate-section]').forEach(function(el){el.classList.add('is-inview')});
}
});
var problemScenes=(function(){var all=Array.prototype.slice.call(root.querySelectorAll('[data-problem-scenes]'));if(!lrMobilePerf)return all[0]||null;return all.find(function(el){return !el.closest('.lr-desktop-v6-only')})||all[0]||null})();
if(problemScenes){
var syncingScenes=false;
var actionRadios=Array.prototype.slice.call(root.querySelectorAll('.lr-scene-radio[data-scene-radio]'));
var problemRadios=Array.prototype.slice.call(problemScenes.querySelectorAll('.lr-problem-scene-radio[data-problem-scene-radio]'));
function setChecked(radioList,attr,slot){
var target=radioList.find(function(r){return r.getAttribute(attr)===String(slot)});
if(target && !target.checked){
target.checked=true;
target.dispatchEvent(new Event('change',{bubbles:true}));
}
}
problemRadios.forEach(function(radio){
radio.addEventListener('change',function(){
if(!radio.checked || syncingScenes)return;
syncingScenes=true;
var slot=radio.getAttribute('data-problem-scene-radio');
setChecked(actionRadios,'data-scene-radio',slot);
if(window.AYLUSceneVideoSwitch)window.AYLUSceneVideoSwitch(root.getAttribute('data-section-id'),slot);
syncingScenes=false;
});
});
actionRadios.forEach(function(radio){
radio.addEventListener('change',function(){
if(!radio.checked || syncingScenes)return;
syncingScenes=true;
var slot=radio.getAttribute('data-scene-radio');
setChecked(problemRadios,'data-problem-scene-radio',slot);
syncingScenes=false;
});
});
var initialAction=actionRadios.find(function(radio){return radio.checked});
if(initialAction){
syncingScenes=true;
setChecked(problemRadios,'data-problem-scene-radio',initialAction.getAttribute('data-scene-radio'));
syncingScenes=false;
}

/* V10: los labels del footer ya no activan el radio mediante su `for`.
   Eso hacía que el navegador enfocase el input oculto y saltase a la imagen superior.
   Cambiamos la escena manualmente sin alterar la posición del scroll. */
var impactNavLabels=Array.prototype.slice.call(root.querySelectorAll('.lr-impact-premium__nav [data-problem-label]'));
impactNavLabels.forEach(function(label){
label.addEventListener('click',function(event){
event.preventDefault();
var slot=label.getAttribute('data-problem-label');
var target=problemRadios.find(function(radio){return radio.getAttribute('data-problem-scene-radio')===String(slot)});
if(!target)return;
if(!target.checked){
target.checked=true;
target.dispatchEvent(new Event('change',{bubbles:true}));
}
});
});
}

/* V39: en móvil, Familia / Conecta / Atención / Empieza controla a la vez
   la imagen de momentos y el vídeo horizontal inmediatamente posterior. */
var mobileMoments=root.querySelector('[data-mobile-moments]');
if(mobileMoments){
  var momentTabs=Array.prototype.slice.call(mobileMoments.querySelectorAll('[data-moment-scene]'));
  var momentSlides=Array.prototype.slice.call(mobileMoments.querySelectorAll('[data-mobile-moment-slot]'));
  var momentAction=root.querySelector('[data-action-scenes]');
  function syncMomentScene(slot,playVideo){
    slot=String(slot||'1');
    momentTabs.forEach(function(btn){var active=btn.getAttribute('data-moment-scene')===slot;btn.classList.toggle('is-active',active);btn.setAttribute('aria-selected',active?'true':'false')});
    momentSlides.forEach(function(slide){slide.classList.toggle('is-active',slide.getAttribute('data-mobile-moment-slot')===slot)});
    if(momentAction){
      var radio=momentAction.querySelector('.lr-scene-radio[data-scene-radio="'+slot+'"]');
      if(radio&&!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}))}
      else if(playVideo&&window.AYLUSceneVideoSwitch){window.AYLUSceneVideoSwitch(root.getAttribute('data-section-id'),slot)}
    }
  }
  momentTabs.forEach(function(btn){btn.addEventListener('click',function(){syncMomentScene(btn.getAttribute('data-moment-scene'),true)})});
  if(momentAction){
    momentAction.querySelectorAll('.lr-scene-radio[data-scene-radio]').forEach(function(radio){radio.addEventListener('change',function(){if(radio.checked)syncMomentScene(radio.getAttribute('data-scene-radio'),false)})});
    var checked=momentAction.querySelector('.lr-scene-radio[data-scene-radio]:checked');
    syncMomentScene(checked?checked.getAttribute('data-scene-radio'):'1',false);
  }else syncMomentScene('1',false);
}

var differences=Array.prototype.slice.call(root.querySelectorAll('[data-difference-carousel]'));
if(lrMobilePerf)differences=differences.filter(function(difference){return !difference.classList.contains('lr-desktop-v6-only')});
differences.forEach(function(difference){
var diffTrack=difference.querySelector('[data-diff-track]');
var diffTabs=Array.prototype.slice.call(difference.querySelectorAll('[data-diff-tab]'));
var diffDots=Array.prototype.slice.call(difference.querySelectorAll('.lr-difference__progress i'));
var diffPrev=difference.querySelector('[data-diff-prev]');
var diffNext=difference.querySelector('[data-diff-next]');
var diffIndex=0;
var diffTouchStart=null;

function diffMaxIndex(){
return difference.classList.contains('lr-mobile-legacy-only')?1:2;
}

function showDifference(index){
var max=diffMaxIndex();
diffIndex=Math.max(0,Math.min(max,index));

if(diffTrack){
diffTrack.style.transform='translate3d(' + (-diffIndex*100) + '%,0,0)';
}

diffTabs.forEach(function(tab,i){
var active=i===diffIndex;
tab.classList.toggle('is-active',active);
tab.setAttribute('aria-selected',active?'true':'false');
});

diffDots.forEach(function(dot,i){
dot.classList.toggle('is-active',i===diffIndex);
});
}

function diffPrevious(){
var max=diffMaxIndex();
showDifference(diffIndex===0?max:diffIndex-1);
}

function diffNextSlide(){
var max=diffMaxIndex();
showDifference(diffIndex===max?0:diffIndex+1);
}

diffTabs.forEach(function(tab){
tab.addEventListener('click',function(){
showDifference(parseInt(tab.getAttribute('data-diff-tab'),10)||0);
});
});

if(diffPrev)diffPrev.addEventListener('click',diffPrevious);
if(diffNext)diffNext.addEventListener('click',diffNextSlide);

if(diffTrack){
diffTrack.addEventListener('touchstart',function(e){
diffTouchStart=e.touches&&e.touches[0]?e.touches[0].clientX:null;
},{passive:true});

diffTrack.addEventListener('touchend',function(e){
if(diffTouchStart===null)return;
var end=e.changedTouches&&e.changedTouches[0]?e.changedTouches[0].clientX:diffTouchStart;
var delta=end-diffTouchStart;
diffTouchStart=null;
if(Math.abs(delta)<45)return;
if(delta<0){diffNextSlide();}else{diffPrevious();}
},{passive:true});
}

showDifference(0);
});
}
function bootLockee(){document.querySelectorAll('[data-lr-root]').forEach(initLockee)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootLockee,{once:true});else bootLockee();
document.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector?e.target.querySelector('[data-lr-root]'):null;if(r)initLockee(r)});;
